/* eslint-disable no-undef */
import { getNextSibling, isNullOrUndefined, getUrlVars } from "/Assets/js/utilities.js";
import intlTelInput from "/Assets/libs/intl-tel-input/js/intlTelInput.js";
import VanillaModal from "/Assets/libs/Modal/VanillaModal.js";
import leadSource from "/Features/Forms/js/lead-source.js";
import campaignSource from "/Features/Forms/js/campaign-source.js";
import { wtbProductInterestData } from "/Features/Forms/js/product-interest-data.js";

export default class EmbeddedFormBlock {
    constructor(embeddedFormBlockCntnr) {
        this.isHidden = (embeddedFormBlockCntnr.dataset.embeddedFormBlockHidden === "True");
        this.embeddedFormBlockCntnr = embeddedFormBlockCntnr;
        this.elementId = this.embeddedFormBlockCntnr.dataset.embeddedFormBlock;
        this.formName = this.embeddedFormBlockCntnr.dataset.embeddedFormBlockName;
        this.recaptchaId = this.embeddedFormBlockCntnr.dataset.recaptchaId;
        this.initializeRecaptcha = (isNullOrUndefined(this.recaptchaId) || this.isHidden) ? false : true;
        this.embeddedFormFields = window.embeddedForms[this.elementId];
        this.formStarted = false;
        this.formCompleted = false;
        this.ebfCallToAction = this.embeddedFormBlockCntnr.dataset.callToAction;
        this.defaultCallToAction = "";
        this.openInModal = Boolean(embeddedFormBlockCntnr.parentNode.closest("#primaryCtaForm"));
        this.disableButtonBlock();
    }

    initialize() {
        this.form = this.embeddedFormBlockCntnr.querySelector("form");
        if (!this.form)
            return;

        this.d365FormName = this.form.dataset.formName;
        this.submitButtonCntnr = this.embeddedFormBlockCntnr.querySelector("[data-editorblocktype=SubmitButtonBlock]");
        this.submitButton = this.submitButtonCntnr.querySelector("button.lp-form-button");

        this.bindEvents();
        this.showTitleDescription();
        this.setLeadSource();
        this.setCampaignSource();
        this.setLanguage();
        this.setWebsiteRegion();
        this.setPageUrl();
        this.setProductInterest();
        this.setCallToAction();
        this.hideFields();
        this.addLoadingSpinner();
        this.initPhone();
        this.countryOnChange();
        this.doYouHaveRobotOnChange();
        this.hideLoader();
        this.enableButtonBlock();
        this.setWtbProductInterestFromUrl();
        this.initRobotmaster();

        if (!isNullOrUndefined(this.d365FormName) && this.d365FormName === "catridge-return-to-recycle") {
            this.initCountry("United States of America", true);
        }
    }

    bindEvents() {
        if (this.isHidden)
            return;

        this.initWtbProductInterestOnChange();
        this.setupModalForm();

        const self = this;
        this.form.addEventListener("input", function () {
            if (!self.formStarted) {
                window.dataLayer.push({
                    event: "formStarted",
                    formId: self.formName
                });
                self.formStarted = true;
            }
        });
    }

    setupModalForm() {
        const primaryCtaForm = document.getElementById("primaryCtaForm");
        if (!primaryCtaForm) return;

        const primaryCtaModal = new VanillaModal("primaryCtaForm",
            {
                onOpen: (e) => {
                    const element = e.target;
                    const title = element.dataset.title;
                    const description = element.dataset.description;
                    const calltoaction = element.dataset.calltoaction;
                    const modal = document.getElementById("primaryCtaForm");

                    if (!isNullOrUndefined(title)) {
                        modal.querySelector(".form-title").textContent = title;
                    }
                    if (!isNullOrUndefined(description)) {
                        modal.querySelector(".form-description").innerHTML = `<p>${description}</p>`;
                    }
                    if (!isNullOrUndefined(calltoaction)) {
                        this.setCallToAction(calltoaction);
                    }
                }
            });
        this.modal = primaryCtaModal;
        this.modal.init();

    }

    disableButtonBlock() {
        if (!this.openInModal)
            return;

        const ctaFormButtons = document.querySelectorAll("[data-target='primaryCtaForm']");
        for (const button of ctaFormButtons) {
            const loadingText = button.dataset.loadingText;
            if (!isNullOrUndefined(loadingText)) {
                button.setAttribute("data-label-text", button.textContent);
                button.innerHTML = loadingText;
                button.disalbled = true;
            }
        }
    }

    enableButtonBlock() {
        if (this.isHidden)
            return;

        const ctaFormButtons = document.querySelectorAll("[data-target='primaryCtaForm']");
        for (const button of ctaFormButtons) {
            const buttonText = button.dataset.labelText;
            if (!isNullOrUndefined(buttonText)) {
                button.innerHTML = buttonText;
                button.disalbled = false;
            }
        }
    }

    showLoader() {
        const self = this;

        const loader = self.embeddedFormBlockCntnr.querySelector("[data-loader]");
        loader.style.display = "block";
    }

    hideLoader() {
        const self = this;

        if (this.isHidden)
            return;

        const loader = self.embeddedFormBlockCntnr.querySelector("[data-loader]");
        loader.style.display = "none";
    }

    showTitleDescription() {
        this.embeddedFormBlockCntnr.querySelector("h3.form-title").classList.remove("hide");
        this.embeddedFormBlockCntnr.querySelector("div.form-description").classList.remove("hide");
    }

    hideFields() {
        if (this.isHidden)
            return;

        if (!isNullOrUndefined(this.d365FormName) && this.d365FormName === "software-for-education-applications") {
            return;
        }

        for (let [key, value] of this.embeddedFormFields.entries()) {
            if (fieldsToHide.includes(key)) {
                const elementToHide = document.getElementById(value);

                if (!elementToHide)
                    return;

                const eth = elementToHide.closest("[data-editorblocktype]");
                eth.style.display = "none";
            }
        }
    }

    addLoadingSpinner() {
        if (this.isHidden)
            return;

        this.submitButton.setAttribute("data-loading-text",
            "<i class='far fa-circle-notch fa-spin' aria-hidden='true'></i>");
    }

    initWtbProductInterestOnChange() {
        const self = this;
        const wtbProductInterestId = this.embeddedFormFields.get("wheretobuyproductinterest");
        const wtbProductInterestInput = document.getElementById(wtbProductInterestId);

        if (!wtbProductInterestInput)
            return;

        document.getElementById(wtbProductInterestId).onchange = function (e) {
            const data = wtbProductInterestData[e.target.value];
            self.setWtbProductInterestValues(data);
        };
    }

    setWtbProductInterestFromUrl() {
        if (this.isHidden)
            return;

        const urlVars = getUrlVars();
        var cat = urlVars.category ? urlVars.category : "";

        if (isNullOrUndefined(cat))
            return;

        this.setPicklistField("wheretobuyproductinterest", cat);

        const data = wtbProductInterestData[cat];
        this.setWtbProductInterestValues(data);
    }

    setWtbProductInterestValues(data) {
        const self = this;
        const technology = data.ht_technologyinterest;
        const platform = data.ht_platform;
        const productClassType = data.ht_productclasstype;

        if (!isNullOrUndefined(technology)) {
            self.setPicklistField("technology", technology);
        }
        else {
            self.clearPickListField("technology");
        }

        if (!isNullOrUndefined(productClassType)) {
            self.setPicklistField("productclasstype", productClassType);
        }
        else {
            self.clearPickListField("productclasstype");
        }

        if (!isNullOrUndefined(platform)) {
            self.setPicklistField("platform", platform);
        }
        else {
            self.clearPickListField("platform");
        }
    }

    initCountry(country, disable = false) {
        const countryId = this.embeddedFormFields.get("country");
        const countryInput = document.getElementById(countryId);

        if (!countryInput)
            return;

        this.dynamicsFillLookupFromSearch(countryId, country);
        if (disable)
            countryInput.disabled = true;
    }

    initMultiSelect(element) {
        const elementContainer = element.closest("[data-editorblocktype]");
        const checkboxesContainer = elementContainer.querySelector(".checkboxes-container");
        const overSelect = elementContainer.querySelector(".overSelect");

        checkboxesContainer.addEventListener("change", event => {
            let selectedInputs = [];

            if (event.target.type === "checkbox") {
                const checked = elementContainer.querySelectorAll('input[type="checkbox"]:checked');
                selectedInputs = Array.from(checked).map(x => x.value);
            }

            let selectedText = "";
            for (let item of selectedInputs) {
                const input = checkboxesContainer.querySelector("input[value='" + item + "']");
                const label = input.nextElementSibling.innerText;
                if (selectedText == "") {
                    selectedText = label;
                } else {
                    selectedText = selectedText + ", " + label;
                }
            }

            const selectedContainer = elementContainer.querySelector(".multiselect-selected");
            selectedContainer.innerHTML = selectedText;
        });

        overSelect.addEventListener("click", function () {
            const isVisible = checkboxesContainer.offsetParent === null;
            if (!isVisible) {
                checkboxesContainer.style.display = "none";
            } else {
                checkboxesContainer.style.display = "block";
            }
        });

        document.addEventListener("click", function (event) {
            const chk = event.target.closest(".checkboxes-container");
            const ovr = event.target.closest(".overSelect");

            if (chk == null && ovr == null) {
                checkboxesContainer.style.display = "none";
            }
        }, false);
    }

    initRobotmaster() {
        const self = this;
        const robotApplicationId = this.embeddedFormFields.get("robotapplication");
        const robotApplication = document.querySelector('[name="' + robotApplicationId + '"]');
        const robotBrandId = this.embeddedFormFields.get("robotbrand");
        const robotBrand = document.querySelector('[name="' + robotBrandId + '"]');

        if (robotApplication) {
            self.initMultiSelect(robotApplication);
        }
        if (robotBrand) {
            self.initMultiSelect(robotBrand);
        }
    }

    dynamicsFillLookupFromSearch(id, value) {
        window.MsCrmMkt.MsCrmFormLoader.fillLookupFromSearch(id, value)
            .then(function () {
                const input = document.getElementById(id);
                const select = getNextSibling(input, "div.ui-selectmenu-menu");
                const item = select.querySelector("ul");
                const firstChild = item.firstChild;
                const itemVal = firstChild.dataset.value;
                const itemText = firstChild.querySelector("div").textContent;
                firstChild.classList.add("ui-state-active");
                input.setAttribute("data-value", itemVal);
                input.value = itemText;
            }).catch(function () {
                console.error("Error performing search");
            });
    }

    initPhone() {
        if (this.isHidden)
            return;

        for (let [key, value] of this.embeddedFormFields.entries()) {
            if (key.includes("phone")) {

                const phoneInput = document.getElementById(value);
                if (!phoneInput)
                    continue;

                phoneInput.setAttribute("data-valid-phone-error-message", window.jsl10n.JsResources.Translations.Common.EnterValidPhoneNumber);

                phoneInput.setAttribute("placeholder", window.jsl10n.JsResources.Translations.Common.SelectCountry);

                intlTelInput(phoneInput, {
                    loadUtils: () => import("/Assets/libs/intl-tel-input/js/utils"),
                    nationalMode: false,
                    strictMode: true,
                    autoPlaceholder: "aggressive",
                    excludeCountries: ["ac", "bq", "ss", "gg"],
                    i18n: localizedCountries,
                    initialCountry: initialCountry
                });
            }
        }
    }

    doYouHaveRobotOnChange() {
        if (this.isHidden)
            return;

        const haveRobotId = this.embeddedFormFields.get("doyouhaverobot");
        const haveRobotInput = document.getElementById(haveRobotId);

        if (!haveRobotInput)
            return;

        var self = this;
        document.addEventListener("input", function (event) {
            if (event.target.id !== haveRobotId) return;

            const value = event.target.value;

            const currentProgrammingMethodId = window.fields.get("currentprogrammingmethod");
            const currentProgrammingMethodInput = document.getElementById(currentProgrammingMethodId);
            const robotBrandId = window.fields.get("robotbrand");
            const robotBrandInput = document.getElementById(robotBrandId);

            if (currentProgrammingMethodInput) {
                if (value === "Yes") {
                    self.showInput(currentProgrammingMethodInput);
                } else {
                    self.hideInput(currentProgrammingMethodInput);
                }
            }
            if (robotBrandInput) {
                if (value === "Yes") {
                    self.showInput(robotBrandInput);
                } else {
                    self.hideInput(robotBrandInput);
                }
            }

        }, false);
    }

    countryOnChange() {
        if (this.isHidden)
            return;

        const countryId = this.embeddedFormFields.get("country");
        const countryInput = document.getElementById(countryId);

        if (!countryInput)
            return;

        var self = this;
        const observer = new MutationObserver(function (mutationList) {
            self.countryOnChangeHandler(mutationList, self);
        });

        const obsConfig = {
            attributes: true,
            attributeFilter: ["data-value"]
        };
        observer.observe(countryInput, obsConfig);
    }

    countryOnChangeHandler(mutationList, self) {
        mutationList.forEach(function () {
            const countryId = window.fields.get("country");
            const cinput = document.getElementById(countryId);
            const value = cinput.dataset.value;
            const countryParentContainer = cinput.closest("[data-editorblocktype]");
            const countryActive = countryParentContainer.querySelector("li.ui-state-active");
            const countryText = countryActive.querySelector(".ui-menu-item-wrapper").textContent;
            const stateId = window.fields.get("state");
            const stateInput = document.getElementById(stateId);
            const cityId = window.fields.get("city");
            const cityInput = document.getElementById(cityId);
            const zipId = window.fields.get("zip");
            const zipInput = document.getElementById(zipId);

            if (stateInput) {
                if (showState.includes(value) || showStateText.includes(countryText)) {
                    self.showInput(stateInput);
                } else {
                    self.hideInput(stateInput);
                }
            }
            if (cityInput) {
                if (showCity.includes(value) || showCityText.includes(countryText)) {
                    self.showInput(cityInput);
                } else {
                    self.hideInput(cityInput);
                }
            }
            if (zipInput) {
                if (showZip.includes(value) || showZipText.includes(countryText)) {
                    self.showInput(zipInput);
                } else {
                    self.hideInput(zipInput);
                }
            }
        });
    }

    showInput(inputEl) {
        const parent = inputEl.closest("[data-editorblocktype]");
        const isMultiSelect = inputEl.closest("div.multiselect") != null;
        const select = parent.querySelector("select");
        const label = parent.querySelector("label.lp-ellipsis");

        // check if required text already exists
        const reqTextExists = label.querySelector(".lp-required");
        if (!reqTextExists) {
            const inputCntnrRequiredLabel = document.createElement("span");
            inputCntnrRequiredLabel.className = "lp-required";
            inputCntnrRequiredLabel.textContent = "*";
            inputCntnrRequiredLabel.style.color = "rgb(255, 0, 0)";
            label.append(inputCntnrRequiredLabel);
        }

        parent.style.display = "block";
        if (isMultiSelect) {
            select.setAttribute("aria-required", "true");
            select.setAttribute("required", "required");
        } else {
            inputEl.setAttribute("aria-required", "true");
            inputEl.setAttribute("required", "required");
        }
    }

    hideInput(inputEl) {
        const parent = inputEl.closest("[data-editorblocktype]");
        const isMultiSelect = inputEl.closest("div.multiselect") != null;
        const select = parent.querySelector("select");

        parent.style.display = "none";

        if (isMultiSelect) {
            select.setAttribute("aria-required", "false");
            select.removeAttribute("required");
        } else {
            inputEl.setAttribute("aria-required", "false");
            inputEl.removeAttribute("required");
        }
    }

    setLeadSource() {
        const ls = new leadSource(this.embeddedFormFields);
        ls.setLeadSource();
    }

    setCampaignSource() {
        const cs = new campaignSource();
        const campaign = cs.getCampaignSourceValue();
        const campaignId = this.embeddedFormFields.get("campaignsource");
        const campaignInput = document.getElementById(campaignId);

        if (!campaignInput || isNullOrUndefined(campaign) || campaign == "null")
            return;

        this.dynamicsFillLookupFromSearch(campaignId, campaign);
    }

    setLanguage() {
        const languageId = this.embeddedFormFields.get("language");
        const languageInput = document.getElementById(languageId);

        if (!languageInput)
            return;

        if (languageInput.value)
            return;

        const language = languages.find(l => l.id === window.currentLanguage);
        if (language !== "") {
            this.dynamicsFillLookupFromSearch(languageId, language.name);
        }
    }

    setCallToAction(calltoaction = null) {
        const callToActionId = this.embeddedFormFields.get("calltoaction");
        const callToActionInput = document.getElementById(callToActionId);

        if (!callToActionInput)
            return;

        let cta;

        if (isNullOrUndefined(calltoaction)) {
            if (callToActionInput.value) {
                this.defaultCallToAction = callToActionInput.value;
                return;
            } else {
                cta = this.ebfCallToAction;
            }

        } else {
            cta = calltoaction;
        }

        if (cta !== "") {
            this.dynamicsFillLookupFromSearch(callToActionId, cta);
        }
        return;
    }

    setProductInterest() {
        const wtbProductInterestId = this.embeddedFormFields.get("wheretobuyproductinterest");
        const wtbProductInterestInput = document.getElementById(wtbProductInterestId);

        if (wtbProductInterestInput)
            return;

        const productInterestData = window.productInterestData;

        const technology = isNullOrUndefined(productInterestData.Technology) ? "" : productInterestData.Technology;
        const productClassType = isNullOrUndefined(productInterestData.ProductClassType) ? "" : productInterestData.ProductClassType;
        const productModelLine = isNullOrUndefined(productInterestData.ProductModelLine) ? "" : productInterestData.ProductModelLine;
        const platform = isNullOrUndefined(productInterestData.Platform) ? "" : productInterestData.Platform;
        const application = isNullOrUndefined(productInterestData.Application) ? "" : productInterestData.Application;
        const materialShape = isNullOrUndefined(productInterestData.MaterialShape) ? "" : productInterestData.MaterialShape;

        if (!isNullOrUndefined(technology)) {
            this.setPicklistField("technology", technology);
        }
        if (!isNullOrUndefined(productClassType)) {
            this.setPicklistField("productclasstype", productClassType);
        }
        if (!isNullOrUndefined(productModelLine)) {
            this.setPicklistField("productmodelline", productModelLine);
        }
        if (!isNullOrUndefined(platform)) {
            this.setPicklistField("platform", platform);
        }
        if (!isNullOrUndefined(application)) {
            this.setCheckboxField("application", application);
        }
        if (!isNullOrUndefined(materialShape)) {
            this.setCheckboxField("materialshape", materialShape);
        }
    }

    setCheckboxField(field, value) {
        const fieldId = this.embeddedFormFields.get(field);
        const input = document.querySelector(`input[name="${fieldId}"][value="${value}"]`);

        if (!input || isNullOrUndefined(value))
            return;

        input.checked = true;
    }

    setPicklistField(field, value) {
        const fieldId = this.embeddedFormFields.get(field);
        const fieldInput = document.getElementById(fieldId);

        if (!fieldInput || isNullOrUndefined(value))
            return;

        for (let i = 0; i < fieldInput.options.length; i++) {
            if (fieldInput.options[i].value === value) {
                fieldInput.selectedIndex = i;
                break;
            }
        }
    }

    clearPickListField(field) {
        const fieldId = this.embeddedFormFields.get(field);
        const fieldInput = document.getElementById(fieldId);

        if (!fieldInput)
            return;

        for (let i = 0; i < fieldInput.options.length; i++) {
            fieldInput[i].selected = false;
        }
    }

    setWebsiteRegion() {
        const websiteRegionId = this.embeddedFormFields.get("websiteregion");
        const websiteRegionInput = document.getElementById(websiteRegionId);

        if (!websiteRegionInput)
            return;

        websiteRegionInput.value = window.currentRegion;
    }

    setPageUrl() {
        const pageUrlId = this.embeddedFormFields.get("pageurl");
        const pageUrlInput = document.getElementById(pageUrlId);

        if (!pageUrlInput)
            return;

        pageUrlInput.value = window.location.href;
    }

    showButtonSubmitting() {
        const text = this.submitButton.dataset.loadingText;
        if (text) {
            this.submitButton.setAttribute("data-label-text", this.submitButton.innerHTML);
            this.submitButton.innerHTML = text;
        }
        this.submitButton.disabled = true;
    }

    showButtonDefault() {
        const text = this.submitButton.dataset.labelText;
        if (text) {
            this.submitButton.innerHTML = text;
        }
        this.submitButton.disabled = false;
    }

    submitForm() {
        this.form.requestSubmit();
    }
}

const languages = [
    { id: "en", name: "English" },
    { id: "es", name: "Spanish" },
    { id: "fr", name: "French" },
    { id: "de", name: "German" },
    { id: "ko", name: "Korean" },
    { id: "zh", name: "Chinese" },
    { id: "it", name: "Italian" },
    { id: "ja", name: "Japanese" },
    { id: "pl", name: "Polish" },
    { id: "pt", name: "Portuguese" },
    { id: "ru", name: "Russian" },
    { id: "tr", name: "Turkish" }
];

const fieldsToHide = [
    "state",
    "city",
    "zip",
    "currentprogrammingmethod",
    "robotbrand"
];

const showState = [
    "ht_countrycodes,djFv6taQpy7RvCECc6KRgOXg2ptZMBunmXxPQu1BFigbGQ==", //CA
    "ht_countrycodes,djGSJKcvAbF1fCaGMtF5XgHTKdLaCh0L18zeLmafuWOoew==", //AU
    "ht_countrycodes,djH0xFsMUkPoZaEtes1cEQ+4XNOBMzWx87lbqtVfd6iylQ==", //NZ
    "ht_countrycodes,djFSwR0x3pX8waDJPLXOR7IrLQZq4aB56pRsoTOvNdHIUA==", //CN
    "ht_countrycodes,djE2hsu6jH/42yyW0KXUowk/mxbYD9VdWj67E7mq+Keriw==", //US
    //OMAX PreProd
    "ht_countrycodes,djGlzVajHxZlYDhrp6nso7hQGZm3urbLa9U/QDoPnGeL2Q==",
    "ht_countrycodes,djGbNVKOVfH+cMYvsqOm80kx26fJxbkuZTFvHhdHKkwiWw==",
    "ht_countrycodes,djG+usor2tJwCbf/nwj8I1fb0dHpPDNslm2MS4lcOhUnnA==",
    "ht_countrycodes,djE6jStoKgX6wY78MfSKXh/8IFCQrpGNyVvzhr0H2oPKBQ==",
    "ht_countrycodes,djHTGIGcr+EtEIt6cUkrfXRMVEc6SpMM8AWOgPbjpZegjQ=="
];

const showStateText = [
    "Australia",
    "Canada",
    "China",
    "New Zealand",
    "United States of America"
];

const showCity = [
    "ht_countrycodes,djFv6taQpy7RvCECc6KRgOXg2ptZMBunmXxPQu1BFigbGQ==", //CA
    "ht_countrycodes,djGSJKcvAbF1fCaGMtF5XgHTKdLaCh0L18zeLmafuWOoew==", //AU
    "ht_countrycodes,djH0xFsMUkPoZaEtes1cEQ+4XNOBMzWx87lbqtVfd6iylQ==", //NZ
    "ht_countrycodes,djE2hsu6jH/42yyW0KXUowk/mxbYD9VdWj67E7mq+Keriw==", //US
    "ht_countrycodes,djEGcf1BugHS+1WMWCl/3vIqX9U46LGEWfqmzbSHGMx6Mw==", //AF
    "ht_countrycodes,djF9XTPALL8hRAC5HvwBFjT4linrsf7V3nK3YeRi4YQW1g==", //AL
    "ht_countrycodes,djHQbdQb2P1QrUlDFHrVvHQ/P+LlvI6zWqvuIJg83090OQ==", //DZ
    "ht_countrycodes,djGvCJmA03e/rj5hOrVVOQWf6/VB1t1W6Qt3S0knFkQMeg==", //AD
    "ht_countrycodes,djF/Zps0PXg5WSRvgZ1ywW8oYBdkNJB9yN8zBFkMYUXoRQ==", //AO
    "ht_countrycodes,djGTq51an6APfWyqBNQ3NyKJBCwMmvGLi4Dqbfx9r0QfPg==", //AM
    "ht_countrycodes,djF5fRLtMARWMJwXbAJY687TiYi+VBGxj3+m5AcSKfplcg==", //AT
    "ht_countrycodes,djFYTi+Ob8Aqt0AUJlDFq2fVeqOhkKhYh2dJ6C3WiWhdPg==", //AZ
    "ht_countrycodes,djE5V6hlTFsqNoCkms/ttxdplOETZxoW3XOTexwijVF45Q==", //BH
    "ht_countrycodes,djEp5kPbAW7o0HNctTXCYnWmZZFaLpJLk9/d2MZmwGmI3g==", //BD
    "ht_countrycodes,djHR29H/ojFs9DbZ6OIv8ag4VL87RWyjztlsJKfxemmHfQ==", //BY
    "ht_countrycodes,djEvK+Lh21xCHlau3+PkxJusKcbs/9E+BTTOi/rX9XsW2A==", //BE
    "ht_countrycodes,djFYeEk6deGYXsHtRdryruAP2UoWATYlcXDr57RnyS5i7A==", //BJ
    "ht_countrycodes,djH7z8CgpfGdV/8QZzy7pnzsyUh/RQcf4FxiOdlfBpw6NQ==", //BA
    "ht_countrycodes,djF0N8PV9IXIJpG/+dyRSBUK50GqRutlmCkmJlX4gFFV9w==", //BW
    "ht_countrycodes,djFzauVFhIvlfrL+lALf7sIxppv9GDM1wcAPTZ9OAbavtw==", //BG
    "ht_countrycodes,djFoZxxC6fOSB3JpbyUk30sJxg1RM7tjC7f3eO4JZuGNSg==", //BF
    "ht_countrycodes,djEJgaWZFHGrPWWGEQvvf8TSopONrMH0BTbKR0vcxOq3hA==", //BI
    "ht_countrycodes,djGZqQOaUsEwVqDmnRd+q0+sq4SL3kM/eDv+gWzSLVD1Fw==", //CM
    "ht_countrycodes,djFNfzioiRwAEoxY6NYR6xXZtF1eFKsAlsiLFxQDIjDPHw==", //CV
    "ht_countrycodes,djEraWo58prpJ6jWtlb3/d9HB8Yr30DdZDB0jcPEaBlUsA==", //CF
    "ht_countrycodes,djHDq+TzZ9CKJ77sUbo9UuRiFfXpFwUR6Qs8SVgDxW8JJw==", //TD
    "ht_countrycodes,djHmJzi71jOH2kWqbOjIsMjf+afZ+os4CF4J2x2qb3KLxw==", //KM
    "ht_countrycodes,djGc9WZKVAPwISELkPdnBVLraYVzS4wrj0FjfAtTCBdcAQ==", //CG
    "ht_countrycodes,djHXmXExPuh8OPuECjEkkfURG3pXmX10p3WD15dCfnmxRA==", //CD
    "ht_countrycodes,djH9ZX0iJBzjY6uZEpi2y9Nzh2M8K9CgHATTFox3csuI5Q==", //CI
    "ht_countrycodes,djHRCVEGi7Gh8gcqTPdtIBFHWCZp2W4BGd/K1EwV3V5kxw==", //HR
    "ht_countrycodes,djGzCh4lOPcimetuQi7oIPFmogrxzm+UJt4Dl5UbVxEK/Q==", //CY
    "ht_countrycodes,djHsU3q+U/5yL9Fo7HmIoE4ekk9MJ66NLGvmRosdeomAog==", //CZ
    "ht_countrycodes,djHeXwxp212sa4v17KU+bz7rr/3fBwrEZyyLpkAet8kNmQ==", //DK
    "ht_countrycodes,djE4hwHN2ibbC5qWx7UqjVYUUosWlbjWDX+MMdRix1aPhg==", //DJ
    "ht_countrycodes,djF61ilk857TbBY8SgGnFj8ye1bJzjd4bnlyhu3Z3fE5Nw==", //EG
    "ht_countrycodes,djGYoayD6IzfyxIq53VTV2UAevcUSjNmgCTJ7WvSYKB7jQ==", //GQ
    "ht_countrycodes,djHP2z/qiGE/fOMHoWsm0lWSQwKVTTzNihev3QmmGRncmg==", //ER
    "ht_countrycodes,djESXjt/o2HAWdlZHehIdlYVCHnrIVAtTplqewQjMXdfQw==", //EE
    "ht_countrycodes,djHqBkrGinDtiCFgfnS/zJGCFVXee0Q2xZ+PmNEqPiGU+Q==", //ET
    "ht_countrycodes,djESP09Ff4t0qs+aaJAsvp6Up94S4DE82UJ+1cqRo9co4w==", //FI
    "ht_countrycodes,djGbSwKmA8X7T7tv51OgzfB3uZSiQP+mE9Txb37Ewu4Eqw==", //FR
    "ht_countrycodes,djEeEtUvawPFK1bTWW+kyQaEFZmw5pEIeKnQfOQ7GxWktQ==", //TF
    "ht_countrycodes,djHWXNcltlww3sNX56hqCOD8R9FBJIjkxr44V1RAoiJ9hw==", //GA
    "ht_countrycodes,djEZMP5BR0ddiaHvZKFegQMhqKC/IYyFojiMI6t3/yZY8Q==", //GM
    "ht_countrycodes,djGyqeMdhJJv77fhDMoRYWWeHPavwYnFtKnq+WlWNbwxVA==", //GE
    "ht_countrycodes,djEZsM61ImCVm6GPSA1MfpSxpPJesfUOXhE9+MvB3MU5cQ==", //DE
    "ht_countrycodes,djEvroCOD0jhVPVnSwmVLYY0KQnbjpW2R6wIwWMajKKelQ==", //GH
    "ht_countrycodes,djHG8/k4unCbpEe8HU64WWZSkvtRP3UMCdP6rFpkAK1ANg==", //GI
    "ht_countrycodes,djHYn38d0M3Mr7nxu653GbXtNrN+yRrsYwc63aMAZb/ntg==", //GR
    "ht_countrycodes,djHgFt9sDICC2wwJ8QFx9CrfYx5kRIUR7g+KNnRoOkvCEg==", //GN
    "ht_countrycodes,djEym7zGGCrU0DnFVdUBeYrybtIgbDAySqnU79OSBGqiVA==", //GW
    "ht_countrycodes,djHQNZ0jC7vBwlkVyW4XEsm+LjpWt7x59AJZrU/TM1G7Eg==", //HU
    "ht_countrycodes,djHRpJrUaa+gUvjJvXNgq1M4r/ANsIlEiEUW/aCY682gOw==", //IS
    "ht_countrycodes,djGuOSNMdGVV9comyQ5ouR6LM9/X0zDFWaYC1lrUsM6Ghg==", //IN
    "ht_countrycodes,djE75b7uYX59s/bHNQFQmS3DxQ1B39ju7YrbqLR06QSC9g==", //IR
    "ht_countrycodes,djE7buJP+v6Y4vXGK+9wi8gIJo/8w6hg9Gj0b+L/Tpa7Lg==", //IQ
    "ht_countrycodes,djGcPRrBA3dseOYOjiBmb5YZEFUzAKCdB+8ReQ7SM5Oiww==", //IE
    "ht_countrycodes,djFNysoa5iYEZqOtWSm7WD77qsL8mn3uRIkM4kxgiCXVxQ==", //IM
    "ht_countrycodes,djH/RgCpVjFny1kvdxNCioWQTsvARq/ioNZ4r6CzQ2D+GQ==", //IL
    "ht_countrycodes,djHtnmSQ78XLICY6ABNMHDJp338vUZF5OUy92BRHpXHBiQ==", //IT
    "ht_countrycodes,djFmYCKExW3PsegtjR8YiGTzewEpa/lnIP4D79CcNpGJkQ==", //JE
    "ht_countrycodes,djGf0yBiWYpSF0rXdhUur2Hqcv9UR6VpCHiyxf3PzlCM6w==", //JO
    "ht_countrycodes,djHp/uMvhsxA+NMFGJC3WS35ctIjxsgETFtc7Z4jf0309g==", //KZ
    "ht_countrycodes,djFT4agXcTfYzLu7y5j6/hiU1Dnf7J4oM/ZBSadIG+x7EQ==", //KE
    "ht_countrycodes,djGoWW8rTHuryETSsetJNxzhTNZOph/Kzl7K01NTgDHiGQ==", //XK
    "ht_countrycodes,djEC8mGz/qwXevI1doeEdu9f9FZy5FQjP7NWn2aZht0YAA==", //KW
    "ht_countrycodes,djHYzvbMO4GhhqElG5K5Wy5dYsvw0WY9+VWqFGil8MNYfA==", //KG
    "ht_countrycodes,djEXSOaKkau6yvpv1//jtCixpPfwDXUG6pJtlW3ymgpVrg==", //LV
    "ht_countrycodes,djH6Y4z5iyVgxKjTjUOVhujRuOrRmgf81h/qDFjIYbRJ6w==", //LB
    "ht_countrycodes,djHd6QRK8e8VGegGm/YhqkH+Nivw11IVR2aLAha5OeeezA==", //LS
    "ht_countrycodes,djHvAJI5ZVEoJ+qDUZ1Yv+dCHTNU6byqz0cFiYOkwleE6w==", //LR
    "ht_countrycodes,djGrYYxeLI+2J0bs2f5Blwuu4kfByhIZ3/XVAF/w8NzigA==", //LY
    "ht_countrycodes,djF6IVZYXXmxSbMzfLE1ZUt6nne8DyBy9edc8w9a5fP4qw==", //LI
    "ht_countrycodes,djGXh8Q2Xm0/i+NBRBr6Bez+Bq3VYSk+h3DtP4F+gwOWhA==", //LT
    "ht_countrycodes,djH646vaAn/DMECDW4FNsxJHMSdQJE30Iion/Vn315m8YQ==", //LU
    "ht_countrycodes,djGYpZfloTtqP9HotjG9g2QIfmwJ8viJfcVXz5C8NER1pw==", //MG
    "ht_countrycodes,djF9zeje3vQzCUdg7pmWuahx9EgUiz57tTr0ntKmy/kWSw==", //MW
    "ht_countrycodes,djF85mT3KWjnFnKS623Y4PkJ92vQSghrhrmm9GYmqEw+hQ==", //ML
    "ht_countrycodes,djHqDYsoWwLIEuv3UUJLvbdosL2lKfkqkHtJ+TgIvm7sVg==", //MT
    "ht_countrycodes,djHOIroduH5DEZKbmc7l2fcfFBPdySmF0IwB+vuzhw6LZA==", //MR
    "ht_countrycodes,djGG7/N2SAKFJGfVVasid6hRt7PbFxQzvdLfYz/LPter7A==", //MU
    "ht_countrycodes,djH+9Up1uvAcCvqr43rr/aHaActGwGclPw6gTNdbR0wCdg==", //YT
    "ht_countrycodes,djEKwSF4J2u3J5D3JQzG1SJhTj3TMX8p9dK50zDcquQobQ==", //MD
    "ht_countrycodes,djHAho+ogWioYO6hz76IFO7LWgIT0Wkhy15uaG8DLm/clA==", //MC
    "ht_countrycodes,djHCqmrHbIQAXPPytfGc7VQpIYa5qqprNVYlGn/+LeMSMQ==", //ME
    "ht_countrycodes,djEof5r61W7NZXStHBNhnWplADiORK4nduMKA59vF5NYkQ==", //MA
    "ht_countrycodes,djEr9+JO3WCarpCPC6xkEk9K3+iptGXpVnfiUby/NBtAFQ==", //MZ
    "ht_countrycodes,djGnvlSTd6sc3B4JDrgf1Z61QJJysafdTFDPfo6AIqV6pw==", //NA
    "ht_countrycodes,djG4tNVPwJ0WdUt3DU4nOJjv+xwUJw6zC4FjP0iJseABOA==", //NL
    "ht_countrycodes,djEDht4FhRYzQ/pyGIB51ofnllq28Ge4+7w+O+To9SfO5Q==", //NE
    "ht_countrycodes,djFBokxo/45iwInZbkOVIicksd14T/ckaxTSk9X6AvGgrg==", //NG
    "ht_countrycodes,djFqx8waI3kaUvw1DZMpFcbq2mV5sZpv456G4V9DV+X/3A==", //MK
    "ht_countrycodes,djF1qTklwk2M+Yz2Z6fG25ptmImm9Z4A4v+aPD7StwMBFw==", //NO
    "ht_countrycodes,djF0KCZXgKiaDgqewXuuzUjYC/JZek2Klv3Z9Y0IPNupDg==", //OM
    "ht_countrycodes,djHDEYA82hMV+y38Ogt872y+Ejnr5TSPNaWoh1TkEzoJ2A==", //PK
    "ht_countrycodes,djHUN3ZNEVRSz2cH6d39GCTzRWdJPZiIC7sI1ubJcxOjqw==", //PL
    "ht_countrycodes,djGzkup2lOpvGV2E0bXNBIQr4XXHNE1skPZrIkdybGawbQ==", //PT
    "ht_countrycodes,djEseUtaELVvfTbnxGPNjXnwYPkacTAr280Mvej2YpnQTA==", //QA
    "ht_countrycodes,djH/u3qWQE3uMvskPAyYPIHM/T4ayV/hEa7AkplsgTWstQ==", //RO
    "ht_countrycodes,djFUOyrOpNpSkMPD4sMTM1d2JDqnfOT1ifgseNemzkVRAw==", //RU
    "ht_countrycodes,djGqAQbIwiRyLWFomagyMhbq+jNATEHnjdcev4jNj/mbIw==", //RW
    "ht_countrycodes,djG1KXt9Ti6h5pCUufzjEgBMweK1UwThh5csFUH7qRVcNg==", //SM
    "ht_countrycodes,djEo/0a907iIMHe7JDmljQjgwIxdWsJPQ/+5MKB5GUskqg==", //ST
    "ht_countrycodes,djEA47RH+2ec5XJ5RljLVP/lyGeS1z1SaVo26mqnKQMTaA==", //SA
    "ht_countrycodes,djHmstHIxMhvyBQprpX5gvEan+/KJzSYbWeE/pltYH5hUw==", //SN
    "ht_countrycodes,djHicWnowA1JItnnguqrvHhsuk49J5nwDNorECTCa2uk3Q==", //RS
    "ht_countrycodes,djH1DLDpLybLtPgFb32vrSaN9kuNR0MQp0IPCiIzHIjzHg==", //SC
    "ht_countrycodes,djGEkx9DIi5txuE1WCcEyzDKtZjBckFCWXR4ziKwUpIwhA==", //SL
    "ht_countrycodes,djFXU8jJX97KzZhGo1jlKa4zfc/GsrtzEqyxJv1KsAegyw==", //SK
    "ht_countrycodes,djG9i6faPDT6rRxjldE9yDd5xJKp6iB/KnfWwBDRP5WREQ==", //SI
    "ht_countrycodes,djGUV3oELWHdD5VYBkMJu3A5hWyapb0wyXRpe+hW19AYdA==", //SO
    "ht_countrycodes,djHSoEfOsp+0f/NupKMtudKgESf9jkA5V33cxFJFsARDzA==", //ZA
    "ht_countrycodes,djG9wFxUvReiiU6jj4KVFo+Ta3RHYlgVosydtrVLF/+ghA==", //ES
    "ht_countrycodes,djGzVwFHgm0LHDLXvSQRcoGKzRmU/wtmt/NpqOwESQOdzw==", //LK
    "ht_countrycodes,djG9+Au57hQ0QSgzbIfeHdmOgULVS1OKcwQ0W5GW95MI0w==", //SH
    "ht_countrycodes,djG3/6Ft8jXRu+NJUtA/+fYY+McqKW6S0AlYqww2g6ZOJw==", //SD
    "ht_countrycodes,djFWFp4WPEdM8vN6eBFh13nzh7j1UALICAC32WlMgGB/Kw==", //SJ
    "ht_countrycodes,djHhy1yiPm2Vmw2zIS3Sn5OEgUKy+ycftb5HASZfhhdm+g==", //SZ
    "ht_countrycodes,djGL4GOuRe1uoDeHWHYmC3xa+qAbkUAY5R+gYxUsgTe5qg==", //SE
    "ht_countrycodes,djFUps1n797/BcIVaXJKtgxoQfmlDV+tw0j2Mna3svjfJA==", //CH
    "ht_countrycodes,djE8gPkZJsGfHYMozlrIo0rnwRrnWwVlavplNIlr1pEYZg==", //SY
    "ht_countrycodes,djE36ogLmYDI2BB7tPXmFJrbbk3UTlEE5qGqcM10xZLkcQ==", //TJ
    "ht_countrycodes,djES9t8BuizU5qXy9N+Wk5bcfee2DPACnJFTBPTl6/KMgQ==", //TZ
    "ht_countrycodes,djEm62A9QRuFrHf5GbWx3NUI+Urij19LY5ve07+25hX+Mw==", //TG
    "ht_countrycodes,djEnAY+WJNPMEtvrMnE/wdpNziQDmqpQB1+3YNQ1anflug==", //TN
    "ht_countrycodes,djEi4QRvtKoQCK6eam9yn5i1ySGs0fxhkk1Jd5fHXmsgVw==", //TR
    "ht_countrycodes,djHG2/gqizy8XHYeEL2R3XlzinCV+m9iOw8WBntevMFgRQ==", //TM
    "ht_countrycodes,djHVlOm96nfSBTV0A0kaTNCYIoES06gRLsZ5iiNVqGyo7A==", //UG
    "ht_countrycodes,djHkaDr3R6OzBkT37buaLL/11v5MypwdHx+wk98rmnM3uw==", //UA
    "ht_countrycodes,djGJktwTQJwCzJ83pDpLW5oxuFGCbWShVEBHsMGhERaA3w==", //AE
    "ht_countrycodes,djE68m0ZLMMC32xt/1YzMnKffIHyLloD0ZlOIPEaSsLS8Q==", //GB
    "ht_countrycodes,djH1qu1/xDjahM5LHJwhqyvFIj9TdYYUrAEhbnVuCruu2w==", //UZ
    "ht_countrycodes,djFaXu9bud8c6CtpVTDEy4LBjauJibbt4nba5HTSrBIYaw==", //EH
    "ht_countrycodes,djEOkf0pS9fHXNBYUIOsRy4wGvuB54zucjact4F28K+feA==", //YE
    "ht_countrycodes,djH6R1qNriNM2EotHZXhHPykXtHK5MRN4VKGT+uy/Oma5Q==", //ZM
    "ht_countrycodes,djHBidGAZjY1JD6Ukgjn0jHyvES5ncXjZkh1bkRtpSWcDA==", //ZW
    //OMAX PreProd
    "ht_countrycodes,djGlzVajHxZlYDhrp6nso7hQGZm3urbLa9U/QDoPnGeL2Q==",
    "ht_countrycodes,djGbNVKOVfH+cMYvsqOm80kx26fJxbkuZTFvHhdHKkwiWw==",
    "ht_countrycodes,djG+usor2tJwCbf/nwj8I1fb0dHpPDNslm2MS4lcOhUnnA==",
    "ht_countrycodes,djE6jStoKgX6wY78MfSKXh/8IFCQrpGNyVvzhr0H2oPKBQ==",
    "ht_countrycodes,djErfsUXBK1DIEkI3fA1ScLp+492n9IQIXLLkF/syytikA==",
    "ht_countrycodes,djFV9hIQi4Ko6MWKD9Mb6so6yswJTXUYMUAHTHd4OK9XBA==",
    "ht_countrycodes,djGiOXDz/1nflSiXTqFNiLutXL4zPxZOG2twc2JE/0wbgw==",
    "ht_countrycodes,djG5tN3JecAt4vyO90UIrDW2cV09tB6S0VwZciCGWUHQ7Q==",
    "ht_countrycodes,djFkjzwdyaRJ8ckU4ruPc4Z/pcz1QRwn7KzYlyZeberpZg==",
    "ht_countrycodes,djECAe+vJValRTKbRWYYKEKGmqQgDv6sstSjQkJzVak/GA==",
    "ht_countrycodes,djEjGqQ0JlbzFSfKQQyWbseT649UPGzqZY8UKdoDnlXFew==",
    "ht_countrycodes,djE+5c83YGpOvxdxzA/fC0jvZs71TAB/rF7KCoYdz+xQAg==",
    "ht_countrycodes,djFwISPPSL9NUSgAPDPHtbxirxQkugoeTYLMddfyHGRcWQ==",
    "ht_countrycodes,djHJV/iqM3XP/YrEgSKV6TdYli69D/BbEV668i0ETAVC+Q==",
    "ht_countrycodes,djGn9rHfK5rkZxFFLvhfDzqdvhCPKtczWrT3HwLW90tDLQ==",
    "ht_countrycodes,djGH0d0rYQml0v/HfaSx3dzeFgGt9eCrAngjAYmA6ikf4Q==",
    "ht_countrycodes,djH4Jx3tBa91sJJVKwavswAqQYBFf9UmhPBGTV96iQ2pFQ==",
    "ht_countrycodes,djGViOw+jYeEElSRfnXCZVohLKcwoowlGdwGpwKOUythVQ==",
    "ht_countrycodes,djHtfSs1simIeHI8hnKo4g1jylgg4VRS63yPxop2eD8lgA==",
    "ht_countrycodes,djEG/Qstx06Wj40DdAWfx8dC5ee0PjfuOzb0gTIU0ezMpA==",
    "ht_countrycodes,djE22uo3qeYuo1p3ofyG8SUqpHMwBhLt2+3RZrsLQ6QAtg==",
    "ht_countrycodes,djHUv/jT5W86nnxGPAwfN24pvLYHqvFdKbiNvn2MbQxZYg==",
    "ht_countrycodes,djEZQzOKoVnpEWXt2ASYqtXpsfAjCYav/WOJoQ2qpojU1g==",
    "ht_countrycodes,djEUMyqtzgEzVYstxrrWAsuS3yMgDS0eOx5Bc7dTNlgkoQ==",
    "ht_countrycodes,djG+KXfyckgatSo6kZMSe6po9UJiev9N2n4fSJePKjCFRw==",
    "ht_countrycodes,djE6ectOByeEpWCshlBdhV8PJHaq+jhYrMJj+Ue9xoOEfg==",
    "ht_countrycodes,djH7u4URYVsTnNlBjv0XFehxwZ6XAaMXNmFA1j6jDsYB1Q==",
    "ht_countrycodes,djEpMeXqjPvCfg9oIeMYSXBAF3m7gcKvmgBuCLmM1CnCHA==",
    "ht_countrycodes,djHMGjWW16kcqq/jGYbPCmhOrW1350/3yIANSbHbmnuPsw==",
    "ht_countrycodes,djE0rKsdYQOBGy2SGnirKp1c1/a6Khlznj5FtndLTevjqg==",
    "ht_countrycodes,djHNn5UhnUm3dyiauHA1F78/kgU5oCR6b7ZHIyAZDhOmWA==",
    "ht_countrycodes,djFL3StDoWO6wzcfuMkgkdD0ITAF2Qor22ihwoULujqx7g==",
    "ht_countrycodes,djFrsadaO+V79LkYJyYAUGZlonFk2umx26vdzIkbLvUEew==",
    "ht_countrycodes,djHMTtpTrO0TSJDmFBk8rq4axFuAtFJTdLDgVFN6Az9khA==",
    "ht_countrycodes,djE68FQjWswVLLwps/MF1nk4JE0TKnLDDI/AkjS+MHcpGg==",
    "ht_countrycodes,djEd+kbqVtiOk9dRprHi5DY1wMJ7tDZkmzdcYZrKVYuVdA==",
    "ht_countrycodes,djHM7iiuz0Mkqj+gnES2+QrEKTQdln0oR3eJVQ4c8GAsCg==",
    "ht_countrycodes,djFYdoEZC8ZKMgFlFVa0KmgMifuKG/CHdojXNeRFB/XlmA==",
    "ht_countrycodes,djEVUEjVkcIhBJQsZUf4auNyxsQJhd/mapMSnFOZTHht4w==",
    "ht_countrycodes,djHk5N9ksCG4GITOW5cRi/gTPNfyQ3m9/Igdg0ikbwgLRg==",
    "ht_countrycodes,djEVPkTWMBFQMkOoLxccNMIPbeXZeiroOXsKulhy9fDiPg==",
    "ht_countrycodes,djHNzfUb4BX2E4qBTTFfVoWJKW4W6BORwXc62DF9GIrMmw==",
    "ht_countrycodes,djGBm9eFfO3mfNKw2fMqkNQHFZZExnEdFLpJCEHatSkPWQ==",
    "ht_countrycodes,djEtGw+GAsRmrLmVM19IAxz367xRwgmMT2thEGWeTnhJfQ==",
    "ht_countrycodes,djHDwjFaqEeZQuMRZ5UXwOS5MQ+fImeMJc8fP4rUhewP2g==",
    "ht_countrycodes,djHjt87zoqFEkS32Sk1yfOgJGA5W+GzFcMOHLT6v0du+bg==",
    "ht_countrycodes,djFo5ceO9Xj8btphZouwltOljTMH/vLJzvmCgoE9DptrDg==",
    "ht_countrycodes,djFB6WiM6e5Weuy8eLzJJo0oFKnT3k33xEPbbh6ym5Sx8w==",
    "ht_countrycodes,djFpi4/j2OP/n+9ppaSWnPIFzQ5KOP0KsmjHRucXaLlZGA==",
    "ht_countrycodes,djFX/cc50KHVa0lPkksEBIFtRhS3wcmZP/aY7+toSFvPHw==",
    "ht_countrycodes,djFYvzjLlQ4LzO5oomFycjMJpKax+J6KQi2DSR5zFclT6A==",
    "ht_countrycodes,djHFnC3gHNTxEembGq/A2S03UlBO0L2Ev2fPhCa+QkEZZA==",
    "ht_countrycodes,djHsPJYUhBBAQcSUMXa3hoZ+nnIOLt4IUmAIjqd0tLRriQ==",
    "ht_countrycodes,djFkM7jLatKAh0Ap8dt56Jyj7rMUeO0uPbJr3GrYI4RPVQ==",
    "ht_countrycodes,djEyL6qxi4E2hUfH+4uG+Upe4XEImI/H693pKgm2TPtgCA==",
    "ht_countrycodes,djFWAsqA/LHajnCTokqaYoN9yjRx6xf23Mp4HgnHBk8qBQ==",
    "ht_countrycodes,djEtvwDYuJoVOf/6eOYemeoLYCYQqnxGfueZ0ZxrfOqqZg==",
    "ht_countrycodes,djGLlLn2dk7PEgmdXHdzvGCkHcVTIa17yeCB4zQwTWebxw==",
    "ht_countrycodes,djG8c2mTdfIjhddHS4UL6V6FgX4wG0uwzX3O+hHYFkfZGw==",
    "ht_countrycodes,djF/9P77BHrdvpby8xLq8DNfZDSPT4FuXkBr7T5WrV9/kg==",
    "ht_countrycodes,djGGu5uFSCoCPEeLrRQn5bsgk70em4+iE+eU+ivjhB12bQ==",
    "ht_countrycodes,djFHwdWYO0ZGQ24zOzdYUZxTHfdFNhqV/gxMrK9xGXEb7A==",
    "ht_countrycodes,djFUA1XGc299ZnpQTaVd4N1ZEZxmC7/2VKoM/FxgYi8fvg==",
    "ht_countrycodes,djGWHEyRoEmwtvgtbD3Yq03Xkb472L5lJIvuYq31qUIobw==",
    "ht_countrycodes,djGSw8gJNePNLFEHrJs0EYMgll3dN+oawfXc0uCGn0wt1A==",
    "ht_countrycodes,djGPRcJnsj4ZxEVurPza+NKYj0fTJWIcBOEhH/t96NPg5A==",
    "ht_countrycodes,djGt3UTBdYOw1veI2y6Ebw/K6Bs47W4XWUJ/ku4kB4KA0g==",
    "ht_countrycodes,djG7AW6AjQsH3NdGqHActB6tmvN58tExhbk6JnPdykHWGQ==",
    "ht_countrycodes,djGKnB0cKCGV6LwJ4J5mn9M1qoaFt10i7YehxJpYTdr7VA==",
    "ht_countrycodes,djFibcS1fAq4ELdjtckuGLsvS8YC+z3j2grS/La7qRCh6A==",
    "ht_countrycodes,djHbZYcE+PgF8XhixhLqvbmOX3YClEZUcnORTETnpv2zkw==",
    "ht_countrycodes,djFhsjDYLqrfId1zMA/xphdLNTn/KpNopWXvgPWaI6HmZw==",
    "ht_countrycodes,djE75SIB19MKK9uCO+hK6llaXEHB0Zl+McHx9eGmvMhdew==",
    "ht_countrycodes,djFPujUy5DxRBp/J7zECf6OfzEPswIhEVPbDVQWBosA76w==",
    "ht_countrycodes,djEz2fenOP/xk2l+9mxZB3WTJ8MiKsTsGlNzppoa8MYCEg==",
    "ht_countrycodes,djGrWypAbC36MYxMu4bXv/etsyzMD5Jv9XVJgHQJxBAJPw==",
    "ht_countrycodes,djFvE7Xs9BcoRI0n6a243vq9xHjW/+oszOHDj95ePOR1ug==",
    "ht_countrycodes,djGeCtF+qh77lKiUXKf7LAMMUeV9d3oyqG0Z101VTnVnmQ==",
    "ht_countrycodes,djEZ/LlKzbCdnzpfxuIJHFvN1lSgJ2fjDWejOqKou93tJw==",
    "ht_countrycodes,djEqEW2PdmvQELP5aD6PzEt0r+4YcNJi4aLlr975wgVboA==",
    "ht_countrycodes,djGvNr5YYSpWyTSke3y6wGTtnKyBvn3IMHk8K3gjXPnFrQ==",
    "ht_countrycodes,djEQnxf63Vdha/zuXzXk9Mp9CDBQKD/daEgwrDg6kZqEXA==",
    "ht_countrycodes,djEea5atEKBeQfLp5bUeckqLVbWD16f/4QXfx7uucfYd5A==",
    "ht_countrycodes,djGp/DU6LXDmsX+R4sZ1kT2jy/V841BwkMVYEOybjHYcmQ==",
    "ht_countrycodes,djGChj5lLYBGNk4iGwWBHjjAh8Sq5syFGBesgwmb9TIcAQ==",
    "ht_countrycodes,djH2W+Dw04pMRTMt0AWnXOAPsJyt+gDt16bleiaRndw5Pw==",
    "ht_countrycodes,djFoGxiXK08kFSlasKv8aM8ZOsYnVWAjmfHzy4mpEEFlUw==",
    "ht_countrycodes,djHqn1lkJ900oysdRJlmUdBvKn37a44xr10V3e8BCH1XcA==",
    "ht_countrycodes,djHnyJFPsEimgGWmHfPuKvrLTFn7cGKeBYui6s2kqsjWww==",
    "ht_countrycodes,djEnHVuAsDH5vSbnnNw8gpmaHSWXxwH+Q7lE0TxbGvabPA==",
    "ht_countrycodes,djE9ZBYwhYg9qpgi2C/AHfSQwX2B0HFLd5Da66YJTqqXyg==",
    "ht_countrycodes,djG6bChhoFlMQNjJjSL9mnbxhaCrzpL5nE3vUs5Z8PtNcg==",
    "ht_countrycodes,djEOsRIGSENspvw3YFQsEhdGgcSKyvU1wa3fL3RuGP79ag==",
    "ht_countrycodes,djFUqEsGXCF8WFMY2wq+YYK4D8vFDYq3Xkj8SzIt5Gnq/g==",
    "ht_countrycodes,djFno15iUk26BGMva6fau9i7s5/OJLZqa5JUxuq/WX+TPQ==",
    "ht_countrycodes,djEewAb6pe1h0Aw/LcSNylXXBdzaO1XhDW6ujchfWFJZug==",
    "ht_countrycodes,djGk1s8gXrbu0Mgh2ZvXYMorNo/ThQPlvUchYNhfzt/ztg==",
    "ht_countrycodes,djHr7nC8a/Lj/0SNzxS+gP8FnqfIaiTVqAAQWayHnV8IyA==",
    "ht_countrycodes,djEhFQedT7EeSJkEJHEkF+QYJKwEzfLodtdp8eIOqtOE2w==",
    "ht_countrycodes,djHxRptu2WJ3C8mQZatmEdZGopSwEwULFps+MfozSLT0Dw==",
    "ht_countrycodes,djHLzdYV3hn5/NHd88MaAmFP+PJjmX2fITMA92e1mdENkg==",
    "ht_countrycodes,djH3TYnhqnzrdgteCgE5JRPy0vy5n8fACUSmzGxYL0ryUw==",
    "ht_countrycodes,djHg33Rba05qua87igcAqDm17xNfTYnLV0o8/SxAN95/+g==",
    "ht_countrycodes,djHI3kmpvYxQhZ/qBECrlZ6TFE0eCkR+s0gNjIUecj7spQ==",
    "ht_countrycodes,djGMcn4racuKzxVY+zbAHN1DcfWTT8dtkWjJu80GQ7m4Kw==",
    "ht_countrycodes,djH7BwRiyai1Ql8BN0ctuuaz7H4YcxSp5MQk5YvMDKDgCg==",
    "ht_countrycodes,djHrITVJcSP0jqyv6lHK+WdKlYzyF3Ig0n3Kej+49IVFIw==",
    "ht_countrycodes,djE/uVuBWnez+TJKlUWhlYIM3qDVZsraSYASth+crTDppQ==",
    "ht_countrycodes,djFwjZUAtttLHqsY8je9mBoYJDJHyqqHb+1bJvthBZbu4w==",
    "ht_countrycodes,djG5WLfv23vTYrIqV8tW2x7SIhxvEKQ09jk7wOEcGurkLQ==",
    "ht_countrycodes,djELAIMQUEREbQvA05uy1k+wkrpdtIeTnfCovJR522D0qg==",
    "ht_countrycodes,djH+pvUGn+LHA4PD3/ag2F8Df3Dy46VCGQHusA71V7eEsw==",
    "ht_countrycodes,djFhvKOPBlhzR4Jjv5BfRxme3dkY16P5yPX2O9NKujUiSA==",
    "ht_countrycodes,djHreYGx4TYrx8t8wkyOj8uaopjUjYwMIrUUGsGjwMnMPQ==",
    "ht_countrycodes,djFL+HI1qm8zt4yEBkrR0bSD82uh7/fH5iSIe6nNLv0jnA==",
    "ht_countrycodes,djFtXZYGZVQA5ebQGQKF8sjzA58moJW1OdKDrr/jHHvF+Q==",
    "ht_countrycodes,djHJB0HzwIRDKLDvlD7A13KkvpvRh5k9KGQ2fRqerhsAOw==",
    "ht_countrycodes,djHBtqvKHUPkGl2Wfd/gH5jiBAqRDqWhhQrSyrTzImx7BQ==",
    "ht_countrycodes,djHhebkkf0gtmAYwc9L2Cn+hnWYmQZk9MJ8Ga0wBURydtg==",
    "ht_countrycodes,djG9STkWhwzE7rh1BBp6WoS+YR4iPJSIAFMHozMUS/tWWg==",
    "ht_countrycodes,djE0Jkvn6VPu4+sUYfnwcL3I1Ut5N/vg8i8qMNNjW7BShg==",
    "ht_countrycodes,djGflwHKXY4/c8w6/xWhW299IhO0TpdN7YfBCai+WXg15g==",
    "ht_countrycodes,djG/NZI+l6Jpd+tgDZUBlMbIevBheYdqCUXHfLFPD5rNLA==",
    "ht_countrycodes,djE4jesHUOEvL3wsAWCFIU4Se/X4zwm9ZW8ZnR2+855qEw==",
    "ht_countrycodes,djFuiHnu6MxDuQ618cEaTPRwPCyw/UCNTwDF4Qp8sNNBwg==",
    "ht_countrycodes,djFm0U9SmKiqsUOjq6aAdbb70i7V9Vqk4dYodQDW1u364g==",
    "ht_countrycodes,djGTwdFvjzLomLIBlC/IdgS8MI7P/nxDEPV6EJYFdHEaNQ==",
    "ht_countrycodes,djEgkeUO1dLIm7x80WFdUilCDZcTUwCwEvnsCTYCEfqnxw==",
    "ht_countrycodes,djFe9uaRHEMv4Zs1oJsO7Ndo5VTbNqJ5cj6Y0MxyVVG45Q==",
    "ht_countrycodes,djFHAV4nb12kM/+14Zrp20hzmKSivkXyUFUSOrRxTb26Ag==",
    "ht_countrycodes,djFucTxL52x1fd/SjhTv2TSvs3gKcaz2oCXebmXvGKTAVw==",
    "ht_countrycodes,djFGCWu/qSlbHcW1BX994GOf07jr5Fm3lNVQOdt1gTQTLA==",
    "ht_countrycodes,djGdVYrl4TWQYtSYvtwIEkf7X1LO6aTglaVSKF+btY7+JA==",
    "ht_countrycodes,djERAdaEAjAKhtOuONaQg+9m5Jidm0NLT7YkjShgQ94p0g==",
    "ht_countrycodes,djF2zqcgpuuhdHpfswnwdx4uI1k8cSAy7lErfm1Bk0Bxgg==",
    "ht_countrycodes,djHDIdLEMnXAhwv2O1ctESfIfak70xlGK73+GsKyYR7aCw==",
    "ht_countrycodes,djH+m7M4l8g/i1w1UuoYyr4bWIOPeMdUgIiYwEsFYlMwWA=="
];

const showCityText = [
    "Australia",
    "Canada",
    "New Zealand",
    "United States of America",
    "Afghanistan",
    "Albania",
    "Algeria",
    "Andorra",
    "Angola",
    "Armenia",
    "Austria",
    "Azerbaijan",
    "Bahrain",
    "Bangladesh",
    "Belarus",
    "Belgium",
    "Benin",
    "Bosnia and Herzegovina",
    "Botswana",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cameroon",
    "Cape Verde",
    "Central African Republic",
    "Chad",
    "Comoros",
    "Congo",
    "Congo, The Dem. Republic Of",
    "Côte d'Ivoire",
    "Croatia",
    "Cyprus",
    "Czech Republic",
    "Denmark",
    "Djibouti",
    "Egypt",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Ethiopia",
    "Finland",
    "France",
    "French Southern Terr.",
    "Gabon",
    "Gambia",
    "Georgia",
    "Germany",
    "Ghana",
    "Gibraltar",
    "Greece",
    "Guinea",
    "Guinea-Bissau",
    "Hungary",
    "Iceland",
    "India",
    "Iran",
    "Iraq",
    "Ireland",
    "Isle of Man",
    "Israel",
    "Italy",
    "Jersey",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kosovo",
    "Kuwait",
    "Kyrgyzstan",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Madagascar",
    "Malawi",
    "Mali",
    "Malta",
    "Mauritania",
    "Mauritius",
    "Mayotte",
    "Moldova",
    "Monaco",
    "Montenegro",
    "Morocco",
    "Mozambique",
    "Namibia",
    "Netherlands",
    "Niger",
    "Nigeria",
    "North Macedonia",
    "Norway",
    "Oman",
    "Pakistan",
    "Poland",
    "Portugal",
    "Qatar",
    "Romania",
    "Russian Federation",
    "Rwanda",
    "San Marino",
    "Sao Tome/Principe",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Slovak Republic",
    "Slovenia",
    "Somalia",
    "South Africa",
    "Spain",
    "Sri Lanka",
    "St. Helena",
    "Sudan",
    "Svalbard/Jan Mayen Isls.",
    "Swaziland",
    "Sweden",
    "Switzerland",
    "Syria",
    "Tajikistan",
    "Tanzania",
    "Togo",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "United Kingdom",
    "Uzbekistan",
    "Western Sahara",
    "Yemen",
    "Zambia",
    "Zimbabwe"
];

const showZip = [
    "ht_countrycodes,djE2hsu6jH/42yyW0KXUowk/mxbYD9VdWj67E7mq+Keriw==", //US
    "ht_countrycodes,djEGcf1BugHS+1WMWCl/3vIqX9U46LGEWfqmzbSHGMx6Mw==", //AF
    "ht_countrycodes,djF9XTPALL8hRAC5HvwBFjT4linrsf7V3nK3YeRi4YQW1g==", //AL
    "ht_countrycodes,djHQbdQb2P1QrUlDFHrVvHQ/P+LlvI6zWqvuIJg83090OQ==", //DZ
    "ht_countrycodes,djGvCJmA03e/rj5hOrVVOQWf6/VB1t1W6Qt3S0knFkQMeg==", //AD
    "ht_countrycodes,djF/Zps0PXg5WSRvgZ1ywW8oYBdkNJB9yN8zBFkMYUXoRQ==", //AO
    "ht_countrycodes,djGTq51an6APfWyqBNQ3NyKJBCwMmvGLi4Dqbfx9r0QfPg==", //AM
    "ht_countrycodes,djF5fRLtMARWMJwXbAJY687TiYi+VBGxj3+m5AcSKfplcg==", //AT
    "ht_countrycodes,djFYTi+Ob8Aqt0AUJlDFq2fVeqOhkKhYh2dJ6C3WiWhdPg==", //AZ
    "ht_countrycodes,djE5V6hlTFsqNoCkms/ttxdplOETZxoW3XOTexwijVF45Q==", //BH
    "ht_countrycodes,djEp5kPbAW7o0HNctTXCYnWmZZFaLpJLk9/d2MZmwGmI3g==", //BD
    "ht_countrycodes,djHR29H/ojFs9DbZ6OIv8ag4VL87RWyjztlsJKfxemmHfQ==", //BY
    "ht_countrycodes,djEvK+Lh21xCHlau3+PkxJusKcbs/9E+BTTOi/rX9XsW2A==", //BE
    "ht_countrycodes,djFYeEk6deGYXsHtRdryruAP2UoWATYlcXDr57RnyS5i7A==", //BJ
    "ht_countrycodes,djH7z8CgpfGdV/8QZzy7pnzsyUh/RQcf4FxiOdlfBpw6NQ==", //BA
    "ht_countrycodes,djF0N8PV9IXIJpG/+dyRSBUK50GqRutlmCkmJlX4gFFV9w==", //BW
    "ht_countrycodes,djFzauVFhIvlfrL+lALf7sIxppv9GDM1wcAPTZ9OAbavtw==", //BG
    "ht_countrycodes,djFoZxxC6fOSB3JpbyUk30sJxg1RM7tjC7f3eO4JZuGNSg==", //BF
    "ht_countrycodes,djEJgaWZFHGrPWWGEQvvf8TSopONrMH0BTbKR0vcxOq3hA==", //BI
    "ht_countrycodes,djGZqQOaUsEwVqDmnRd+q0+sq4SL3kM/eDv+gWzSLVD1Fw==", //CM
    "ht_countrycodes,djFNfzioiRwAEoxY6NYR6xXZtF1eFKsAlsiLFxQDIjDPHw==", //CV
    "ht_countrycodes,djEraWo58prpJ6jWtlb3/d9HB8Yr30DdZDB0jcPEaBlUsA==", //CF
    "ht_countrycodes,djHDq+TzZ9CKJ77sUbo9UuRiFfXpFwUR6Qs8SVgDxW8JJw==", //TD
    "ht_countrycodes,djHmJzi71jOH2kWqbOjIsMjf+afZ+os4CF4J2x2qb3KLxw==", //KM
    "ht_countrycodes,djGc9WZKVAPwISELkPdnBVLraYVzS4wrj0FjfAtTCBdcAQ==", //CG
    "ht_countrycodes,djHXmXExPuh8OPuECjEkkfURG3pXmX10p3WD15dCfnmxRA==", //CD
    "ht_countrycodes,djH9ZX0iJBzjY6uZEpi2y9Nzh2M8K9CgHATTFox3csuI5Q==", //CI
    "ht_countrycodes,djHRCVEGi7Gh8gcqTPdtIBFHWCZp2W4BGd/K1EwV3V5kxw==", //HR
    "ht_countrycodes,djGzCh4lOPcimetuQi7oIPFmogrxzm+UJt4Dl5UbVxEK/Q==", //CY
    "ht_countrycodes,djHsU3q+U/5yL9Fo7HmIoE4ekk9MJ66NLGvmRosdeomAog==", //CZ
    "ht_countrycodes,djHeXwxp212sa4v17KU+bz7rr/3fBwrEZyyLpkAet8kNmQ==", //DK
    "ht_countrycodes,djE4hwHN2ibbC5qWx7UqjVYUUosWlbjWDX+MMdRix1aPhg==", //DJ
    "ht_countrycodes,djF61ilk857TbBY8SgGnFj8ye1bJzjd4bnlyhu3Z3fE5Nw==", //EG
    "ht_countrycodes,djGYoayD6IzfyxIq53VTV2UAevcUSjNmgCTJ7WvSYKB7jQ==", //GQ
    "ht_countrycodes,djHP2z/qiGE/fOMHoWsm0lWSQwKVTTzNihev3QmmGRncmg==", //ER
    "ht_countrycodes,djESXjt/o2HAWdlZHehIdlYVCHnrIVAtTplqewQjMXdfQw==", //EE
    "ht_countrycodes,djHqBkrGinDtiCFgfnS/zJGCFVXee0Q2xZ+PmNEqPiGU+Q==", //ET
    "ht_countrycodes,djESP09Ff4t0qs+aaJAsvp6Up94S4DE82UJ+1cqRo9co4w==", //FI
    "ht_countrycodes,djGbSwKmA8X7T7tv51OgzfB3uZSiQP+mE9Txb37Ewu4Eqw==", //FR
    "ht_countrycodes,djEeEtUvawPFK1bTWW+kyQaEFZmw5pEIeKnQfOQ7GxWktQ==", //TF
    "ht_countrycodes,djHWXNcltlww3sNX56hqCOD8R9FBJIjkxr44V1RAoiJ9hw==", //GA
    "ht_countrycodes,djEZMP5BR0ddiaHvZKFegQMhqKC/IYyFojiMI6t3/yZY8Q==", //GM
    "ht_countrycodes,djGyqeMdhJJv77fhDMoRYWWeHPavwYnFtKnq+WlWNbwxVA==", //GE
    "ht_countrycodes,djEZsM61ImCVm6GPSA1MfpSxpPJesfUOXhE9+MvB3MU5cQ==", //DE
    "ht_countrycodes,djEvroCOD0jhVPVnSwmVLYY0KQnbjpW2R6wIwWMajKKelQ==", //GH
    "ht_countrycodes,djHG8/k4unCbpEe8HU64WWZSkvtRP3UMCdP6rFpkAK1ANg==", //GI
    "ht_countrycodes,djHYn38d0M3Mr7nxu653GbXtNrN+yRrsYwc63aMAZb/ntg==", //GR
    "ht_countrycodes,djHgFt9sDICC2wwJ8QFx9CrfYx5kRIUR7g+KNnRoOkvCEg==", //GN
    "ht_countrycodes,djEym7zGGCrU0DnFVdUBeYrybtIgbDAySqnU79OSBGqiVA==", //GW
    "ht_countrycodes,djHQNZ0jC7vBwlkVyW4XEsm+LjpWt7x59AJZrU/TM1G7Eg==", //HU
    "ht_countrycodes,djHRpJrUaa+gUvjJvXNgq1M4r/ANsIlEiEUW/aCY682gOw==", //IS
    "ht_countrycodes,djGuOSNMdGVV9comyQ5ouR6LM9/X0zDFWaYC1lrUsM6Ghg==", //IN
    "ht_countrycodes,djE75b7uYX59s/bHNQFQmS3DxQ1B39ju7YrbqLR06QSC9g==", //IR
    "ht_countrycodes,djE7buJP+v6Y4vXGK+9wi8gIJo/8w6hg9Gj0b+L/Tpa7Lg==", //IQ
    "ht_countrycodes,djGcPRrBA3dseOYOjiBmb5YZEFUzAKCdB+8ReQ7SM5Oiww==", //IE
    "ht_countrycodes,djFNysoa5iYEZqOtWSm7WD77qsL8mn3uRIkM4kxgiCXVxQ==", //IM
    "ht_countrycodes,djH/RgCpVjFny1kvdxNCioWQTsvARq/ioNZ4r6CzQ2D+GQ==", //IL
    "ht_countrycodes,djHtnmSQ78XLICY6ABNMHDJp338vUZF5OUy92BRHpXHBiQ==", //IT
    "ht_countrycodes,djFmYCKExW3PsegtjR8YiGTzewEpa/lnIP4D79CcNpGJkQ==", //JE
    "ht_countrycodes,djGf0yBiWYpSF0rXdhUur2Hqcv9UR6VpCHiyxf3PzlCM6w==", //JO
    "ht_countrycodes,djHp/uMvhsxA+NMFGJC3WS35ctIjxsgETFtc7Z4jf0309g==", //KZ
    "ht_countrycodes,djFT4agXcTfYzLu7y5j6/hiU1Dnf7J4oM/ZBSadIG+x7EQ==", //KE
    "ht_countrycodes,djGoWW8rTHuryETSsetJNxzhTNZOph/Kzl7K01NTgDHiGQ==", //XK
    "ht_countrycodes,djEC8mGz/qwXevI1doeEdu9f9FZy5FQjP7NWn2aZht0YAA==", //KW
    "ht_countrycodes,djHYzvbMO4GhhqElG5K5Wy5dYsvw0WY9+VWqFGil8MNYfA==", //KG
    "ht_countrycodes,djEXSOaKkau6yvpv1//jtCixpPfwDXUG6pJtlW3ymgpVrg==", //LV
    "ht_countrycodes,djH6Y4z5iyVgxKjTjUOVhujRuOrRmgf81h/qDFjIYbRJ6w==", //LB
    "ht_countrycodes,djHd6QRK8e8VGegGm/YhqkH+Nivw11IVR2aLAha5OeeezA==", //LS
    "ht_countrycodes,djHvAJI5ZVEoJ+qDUZ1Yv+dCHTNU6byqz0cFiYOkwleE6w==", //LR
    "ht_countrycodes,djGrYYxeLI+2J0bs2f5Blwuu4kfByhIZ3/XVAF/w8NzigA==", //LY
    "ht_countrycodes,djF6IVZYXXmxSbMzfLE1ZUt6nne8DyBy9edc8w9a5fP4qw==", //LI
    "ht_countrycodes,djGXh8Q2Xm0/i+NBRBr6Bez+Bq3VYSk+h3DtP4F+gwOWhA==", //LT
    "ht_countrycodes,djH646vaAn/DMECDW4FNsxJHMSdQJE30Iion/Vn315m8YQ==", //LU
    "ht_countrycodes,djGYpZfloTtqP9HotjG9g2QIfmwJ8viJfcVXz5C8NER1pw==", //MG
    "ht_countrycodes,djF9zeje3vQzCUdg7pmWuahx9EgUiz57tTr0ntKmy/kWSw==", //MW
    "ht_countrycodes,djF85mT3KWjnFnKS623Y4PkJ92vQSghrhrmm9GYmqEw+hQ==", //ML
    "ht_countrycodes,djHqDYsoWwLIEuv3UUJLvbdosL2lKfkqkHtJ+TgIvm7sVg==", //MT
    "ht_countrycodes,djHOIroduH5DEZKbmc7l2fcfFBPdySmF0IwB+vuzhw6LZA==", //MR
    "ht_countrycodes,djGG7/N2SAKFJGfVVasid6hRt7PbFxQzvdLfYz/LPter7A==", //MU
    "ht_countrycodes,djH+9Up1uvAcCvqr43rr/aHaActGwGclPw6gTNdbR0wCdg==", //YT
    "ht_countrycodes,djEKwSF4J2u3J5D3JQzG1SJhTj3TMX8p9dK50zDcquQobQ==", //MD
    "ht_countrycodes,djHAho+ogWioYO6hz76IFO7LWgIT0Wkhy15uaG8DLm/clA==", //MC
    "ht_countrycodes,djHCqmrHbIQAXPPytfGc7VQpIYa5qqprNVYlGn/+LeMSMQ==", //ME
    "ht_countrycodes,djEof5r61W7NZXStHBNhnWplADiORK4nduMKA59vF5NYkQ==", //MA
    "ht_countrycodes,djEr9+JO3WCarpCPC6xkEk9K3+iptGXpVnfiUby/NBtAFQ==", //MZ
    "ht_countrycodes,djGnvlSTd6sc3B4JDrgf1Z61QJJysafdTFDPfo6AIqV6pw==", //NA
    "ht_countrycodes,djG4tNVPwJ0WdUt3DU4nOJjv+xwUJw6zC4FjP0iJseABOA==", //NL
    "ht_countrycodes,djEDht4FhRYzQ/pyGIB51ofnllq28Ge4+7w+O+To9SfO5Q==", //NE
    "ht_countrycodes,djFBokxo/45iwInZbkOVIicksd14T/ckaxTSk9X6AvGgrg==", //NG
    "ht_countrycodes,djFqx8waI3kaUvw1DZMpFcbq2mV5sZpv456G4V9DV+X/3A==", //MK
    "ht_countrycodes,djF1qTklwk2M+Yz2Z6fG25ptmImm9Z4A4v+aPD7StwMBFw==", //NO
    "ht_countrycodes,djF0KCZXgKiaDgqewXuuzUjYC/JZek2Klv3Z9Y0IPNupDg==", //OM
    "ht_countrycodes,djHDEYA82hMV+y38Ogt872y+Ejnr5TSPNaWoh1TkEzoJ2A==", //PK
    "ht_countrycodes,djHUN3ZNEVRSz2cH6d39GCTzRWdJPZiIC7sI1ubJcxOjqw==", //PL
    "ht_countrycodes,djGzkup2lOpvGV2E0bXNBIQr4XXHNE1skPZrIkdybGawbQ==", //PT
    "ht_countrycodes,djEseUtaELVvfTbnxGPNjXnwYPkacTAr280Mvej2YpnQTA==", //QA
    "ht_countrycodes,djH/u3qWQE3uMvskPAyYPIHM/T4ayV/hEa7AkplsgTWstQ==", //RO
    "ht_countrycodes,djFUOyrOpNpSkMPD4sMTM1d2JDqnfOT1ifgseNemzkVRAw==", //RU
    "ht_countrycodes,djGqAQbIwiRyLWFomagyMhbq+jNATEHnjdcev4jNj/mbIw==", //RW
    "ht_countrycodes,djG1KXt9Ti6h5pCUufzjEgBMweK1UwThh5csFUH7qRVcNg==", //SM
    "ht_countrycodes,djEo/0a907iIMHe7JDmljQjgwIxdWsJPQ/+5MKB5GUskqg==", //ST
    "ht_countrycodes,djEA47RH+2ec5XJ5RljLVP/lyGeS1z1SaVo26mqnKQMTaA==", //SA
    "ht_countrycodes,djHmstHIxMhvyBQprpX5gvEan+/KJzSYbWeE/pltYH5hUw==", //SN
    "ht_countrycodes,djHicWnowA1JItnnguqrvHhsuk49J5nwDNorECTCa2uk3Q==", //RS
    "ht_countrycodes,djH1DLDpLybLtPgFb32vrSaN9kuNR0MQp0IPCiIzHIjzHg==", //SC
    "ht_countrycodes,djGEkx9DIi5txuE1WCcEyzDKtZjBckFCWXR4ziKwUpIwhA==", //SL
    "ht_countrycodes,djFXU8jJX97KzZhGo1jlKa4zfc/GsrtzEqyxJv1KsAegyw==", //SK
    "ht_countrycodes,djG9i6faPDT6rRxjldE9yDd5xJKp6iB/KnfWwBDRP5WREQ==", //SI
    "ht_countrycodes,djGUV3oELWHdD5VYBkMJu3A5hWyapb0wyXRpe+hW19AYdA==", //SO
    "ht_countrycodes,djHSoEfOsp+0f/NupKMtudKgESf9jkA5V33cxFJFsARDzA==", //ZA
    "ht_countrycodes,djG9wFxUvReiiU6jj4KVFo+Ta3RHYlgVosydtrVLF/+ghA==", //ES
    "ht_countrycodes,djGzVwFHgm0LHDLXvSQRcoGKzRmU/wtmt/NpqOwESQOdzw==", //LK
    "ht_countrycodes,djG9+Au57hQ0QSgzbIfeHdmOgULVS1OKcwQ0W5GW95MI0w==", //SH
    "ht_countrycodes,djG3/6Ft8jXRu+NJUtA/+fYY+McqKW6S0AlYqww2g6ZOJw==", //SD
    "ht_countrycodes,djFWFp4WPEdM8vN6eBFh13nzh7j1UALICAC32WlMgGB/Kw==", //SJ
    "ht_countrycodes,djHhy1yiPm2Vmw2zIS3Sn5OEgUKy+ycftb5HASZfhhdm+g==", //SZ
    "ht_countrycodes,djGL4GOuRe1uoDeHWHYmC3xa+qAbkUAY5R+gYxUsgTe5qg==", //SE
    "ht_countrycodes,djFUps1n797/BcIVaXJKtgxoQfmlDV+tw0j2Mna3svjfJA==", //CH
    "ht_countrycodes,djE8gPkZJsGfHYMozlrIo0rnwRrnWwVlavplNIlr1pEYZg==", //SY
    "ht_countrycodes,djE36ogLmYDI2BB7tPXmFJrbbk3UTlEE5qGqcM10xZLkcQ==", //TJ
    "ht_countrycodes,djES9t8BuizU5qXy9N+Wk5bcfee2DPACnJFTBPTl6/KMgQ==", //TZ
    "ht_countrycodes,djEm62A9QRuFrHf5GbWx3NUI+Urij19LY5ve07+25hX+Mw==", //TG
    "ht_countrycodes,djEnAY+WJNPMEtvrMnE/wdpNziQDmqpQB1+3YNQ1anflug==", //TN
    "ht_countrycodes,djEi4QRvtKoQCK6eam9yn5i1ySGs0fxhkk1Jd5fHXmsgVw==", //TR
    "ht_countrycodes,djHG2/gqizy8XHYeEL2R3XlzinCV+m9iOw8WBntevMFgRQ==", //TM
    "ht_countrycodes,djHVlOm96nfSBTV0A0kaTNCYIoES06gRLsZ5iiNVqGyo7A==", //UG
    "ht_countrycodes,djHkaDr3R6OzBkT37buaLL/11v5MypwdHx+wk98rmnM3uw==", //UA
    "ht_countrycodes,djGJktwTQJwCzJ83pDpLW5oxuFGCbWShVEBHsMGhERaA3w==", //AE
    "ht_countrycodes,djE68m0ZLMMC32xt/1YzMnKffIHyLloD0ZlOIPEaSsLS8Q==", //GB
    "ht_countrycodes,djH1qu1/xDjahM5LHJwhqyvFIj9TdYYUrAEhbnVuCruu2w==", //UZ
    "ht_countrycodes,djFaXu9bud8c6CtpVTDEy4LBjauJibbt4nba5HTSrBIYaw==", //EH
    "ht_countrycodes,djEOkf0pS9fHXNBYUIOsRy4wGvuB54zucjact4F28K+feA==", //YE
    "ht_countrycodes,djH6R1qNriNM2EotHZXhHPykXtHK5MRN4VKGT+uy/Oma5Q==", //ZM
    "ht_countrycodes,djHBidGAZjY1JD6Ukgjn0jHyvES5ncXjZkh1bkRtpSWcDA==", //ZW
    //OMAX PreProd
    "ht_countrycodes,djGlzVajHxZlYDhrp6nso7hQGZm3urbLa9U/QDoPnGeL2Q==",
    "ht_countrycodes,djErfsUXBK1DIEkI3fA1ScLp+492n9IQIXLLkF/syytikA==",
    "ht_countrycodes,djFV9hIQi4Ko6MWKD9Mb6so6yswJTXUYMUAHTHd4OK9XBA==",
    "ht_countrycodes,djGiOXDz/1nflSiXTqFNiLutXL4zPxZOG2twc2JE/0wbgw==",
    "ht_countrycodes,djG5tN3JecAt4vyO90UIrDW2cV09tB6S0VwZciCGWUHQ7Q==",
    "ht_countrycodes,djFkjzwdyaRJ8ckU4ruPc4Z/pcz1QRwn7KzYlyZeberpZg==",
    "ht_countrycodes,djECAe+vJValRTKbRWYYKEKGmqQgDv6sstSjQkJzVak/GA==",
    "ht_countrycodes,djEjGqQ0JlbzFSfKQQyWbseT649UPGzqZY8UKdoDnlXFew==",
    "ht_countrycodes,djE+5c83YGpOvxdxzA/fC0jvZs71TAB/rF7KCoYdz+xQAg==",
    "ht_countrycodes,djFwISPPSL9NUSgAPDPHtbxirxQkugoeTYLMddfyHGRcWQ==",
    "ht_countrycodes,djHJV/iqM3XP/YrEgSKV6TdYli69D/BbEV668i0ETAVC+Q==",
    "ht_countrycodes,djGn9rHfK5rkZxFFLvhfDzqdvhCPKtczWrT3HwLW90tDLQ==",
    "ht_countrycodes,djGH0d0rYQml0v/HfaSx3dzeFgGt9eCrAngjAYmA6ikf4Q==",
    "ht_countrycodes,djH4Jx3tBa91sJJVKwavswAqQYBFf9UmhPBGTV96iQ2pFQ==",
    "ht_countrycodes,djGViOw+jYeEElSRfnXCZVohLKcwoowlGdwGpwKOUythVQ==",
    "ht_countrycodes,djHtfSs1simIeHI8hnKo4g1jylgg4VRS63yPxop2eD8lgA==",
    "ht_countrycodes,djEG/Qstx06Wj40DdAWfx8dC5ee0PjfuOzb0gTIU0ezMpA==",
    "ht_countrycodes,djE22uo3qeYuo1p3ofyG8SUqpHMwBhLt2+3RZrsLQ6QAtg==",
    "ht_countrycodes,djHUv/jT5W86nnxGPAwfN24pvLYHqvFdKbiNvn2MbQxZYg==",
    "ht_countrycodes,djEZQzOKoVnpEWXt2ASYqtXpsfAjCYav/WOJoQ2qpojU1g==",
    "ht_countrycodes,djEUMyqtzgEzVYstxrrWAsuS3yMgDS0eOx5Bc7dTNlgkoQ==",
    "ht_countrycodes,djG+KXfyckgatSo6kZMSe6po9UJiev9N2n4fSJePKjCFRw==",
    "ht_countrycodes,djE6ectOByeEpWCshlBdhV8PJHaq+jhYrMJj+Ue9xoOEfg==",
    "ht_countrycodes,djH7u4URYVsTnNlBjv0XFehxwZ6XAaMXNmFA1j6jDsYB1Q==",
    "ht_countrycodes,djEpMeXqjPvCfg9oIeMYSXBAF3m7gcKvmgBuCLmM1CnCHA==",
    "ht_countrycodes,djHMGjWW16kcqq/jGYbPCmhOrW1350/3yIANSbHbmnuPsw==",
    "ht_countrycodes,djE0rKsdYQOBGy2SGnirKp1c1/a6Khlznj5FtndLTevjqg==",
    "ht_countrycodes,djHNn5UhnUm3dyiauHA1F78/kgU5oCR6b7ZHIyAZDhOmWA==",
    "ht_countrycodes,djFL3StDoWO6wzcfuMkgkdD0ITAF2Qor22ihwoULujqx7g==",
    "ht_countrycodes,djFrsadaO+V79LkYJyYAUGZlonFk2umx26vdzIkbLvUEew==",
    "ht_countrycodes,djHMTtpTrO0TSJDmFBk8rq4axFuAtFJTdLDgVFN6Az9khA==",
    "ht_countrycodes,djE68FQjWswVLLwps/MF1nk4JE0TKnLDDI/AkjS+MHcpGg==",
    "ht_countrycodes,djEd+kbqVtiOk9dRprHi5DY1wMJ7tDZkmzdcYZrKVYuVdA==",
    "ht_countrycodes,djHM7iiuz0Mkqj+gnES2+QrEKTQdln0oR3eJVQ4c8GAsCg==",
    "ht_countrycodes,djFYdoEZC8ZKMgFlFVa0KmgMifuKG/CHdojXNeRFB/XlmA==",
    "ht_countrycodes,djEVUEjVkcIhBJQsZUf4auNyxsQJhd/mapMSnFOZTHht4w==",
    "ht_countrycodes,djHk5N9ksCG4GITOW5cRi/gTPNfyQ3m9/Igdg0ikbwgLRg==",
    "ht_countrycodes,djEVPkTWMBFQMkOoLxccNMIPbeXZeiroOXsKulhy9fDiPg==",
    "ht_countrycodes,djHNzfUb4BX2E4qBTTFfVoWJKW4W6BORwXc62DF9GIrMmw==",
    "ht_countrycodes,djGBm9eFfO3mfNKw2fMqkNQHFZZExnEdFLpJCEHatSkPWQ==",
    "ht_countrycodes,djEtGw+GAsRmrLmVM19IAxz367xRwgmMT2thEGWeTnhJfQ==",
    "ht_countrycodes,djHDwjFaqEeZQuMRZ5UXwOS5MQ+fImeMJc8fP4rUhewP2g==",
    "ht_countrycodes,djHjt87zoqFEkS32Sk1yfOgJGA5W+GzFcMOHLT6v0du+bg==",
    "ht_countrycodes,djFo5ceO9Xj8btphZouwltOljTMH/vLJzvmCgoE9DptrDg==",
    "ht_countrycodes,djFB6WiM6e5Weuy8eLzJJo0oFKnT3k33xEPbbh6ym5Sx8w==",
    "ht_countrycodes,djFpi4/j2OP/n+9ppaSWnPIFzQ5KOP0KsmjHRucXaLlZGA==",
    "ht_countrycodes,djFX/cc50KHVa0lPkksEBIFtRhS3wcmZP/aY7+toSFvPHw==",
    "ht_countrycodes,djFYvzjLlQ4LzO5oomFycjMJpKax+J6KQi2DSR5zFclT6A==",
    "ht_countrycodes,djHFnC3gHNTxEembGq/A2S03UlBO0L2Ev2fPhCa+QkEZZA==",
    "ht_countrycodes,djHsPJYUhBBAQcSUMXa3hoZ+nnIOLt4IUmAIjqd0tLRriQ==",
    "ht_countrycodes,djFkM7jLatKAh0Ap8dt56Jyj7rMUeO0uPbJr3GrYI4RPVQ==",
    "ht_countrycodes,djEyL6qxi4E2hUfH+4uG+Upe4XEImI/H693pKgm2TPtgCA==",
    "ht_countrycodes,djFWAsqA/LHajnCTokqaYoN9yjRx6xf23Mp4HgnHBk8qBQ==",
    "ht_countrycodes,djEtvwDYuJoVOf/6eOYemeoLYCYQqnxGfueZ0ZxrfOqqZg==",
    "ht_countrycodes,djGLlLn2dk7PEgmdXHdzvGCkHcVTIa17yeCB4zQwTWebxw==",
    "ht_countrycodes,djG8c2mTdfIjhddHS4UL6V6FgX4wG0uwzX3O+hHYFkfZGw==",
    "ht_countrycodes,djF/9P77BHrdvpby8xLq8DNfZDSPT4FuXkBr7T5WrV9/kg==",
    "ht_countrycodes,djGGu5uFSCoCPEeLrRQn5bsgk70em4+iE+eU+ivjhB12bQ==",
    "ht_countrycodes,djFHwdWYO0ZGQ24zOzdYUZxTHfdFNhqV/gxMrK9xGXEb7A==",
    "ht_countrycodes,djFUA1XGc299ZnpQTaVd4N1ZEZxmC7/2VKoM/FxgYi8fvg==",
    "ht_countrycodes,djGWHEyRoEmwtvgtbD3Yq03Xkb472L5lJIvuYq31qUIobw==",
    "ht_countrycodes,djGSw8gJNePNLFEHrJs0EYMgll3dN+oawfXc0uCGn0wt1A==",
    "ht_countrycodes,djGPRcJnsj4ZxEVurPza+NKYj0fTJWIcBOEhH/t96NPg5A==",
    "ht_countrycodes,djGt3UTBdYOw1veI2y6Ebw/K6Bs47W4XWUJ/ku4kB4KA0g==",
    "ht_countrycodes,djG7AW6AjQsH3NdGqHActB6tmvN58tExhbk6JnPdykHWGQ==",
    "ht_countrycodes,djGKnB0cKCGV6LwJ4J5mn9M1qoaFt10i7YehxJpYTdr7VA==",
    "ht_countrycodes,djFibcS1fAq4ELdjtckuGLsvS8YC+z3j2grS/La7qRCh6A==",
    "ht_countrycodes,djHbZYcE+PgF8XhixhLqvbmOX3YClEZUcnORTETnpv2zkw==",
    "ht_countrycodes,djFhsjDYLqrfId1zMA/xphdLNTn/KpNopWXvgPWaI6HmZw==",
    "ht_countrycodes,djE75SIB19MKK9uCO+hK6llaXEHB0Zl+McHx9eGmvMhdew==",
    "ht_countrycodes,djFPujUy5DxRBp/J7zECf6OfzEPswIhEVPbDVQWBosA76w==",
    "ht_countrycodes,djEz2fenOP/xk2l+9mxZB3WTJ8MiKsTsGlNzppoa8MYCEg==",
    "ht_countrycodes,djGrWypAbC36MYxMu4bXv/etsyzMD5Jv9XVJgHQJxBAJPw==",
    "ht_countrycodes,djFvE7Xs9BcoRI0n6a243vq9xHjW/+oszOHDj95ePOR1ug==",
    "ht_countrycodes,djGeCtF+qh77lKiUXKf7LAMMUeV9d3oyqG0Z101VTnVnmQ==",
    "ht_countrycodes,djEZ/LlKzbCdnzpfxuIJHFvN1lSgJ2fjDWejOqKou93tJw==",
    "ht_countrycodes,djEqEW2PdmvQELP5aD6PzEt0r+4YcNJi4aLlr975wgVboA==",
    "ht_countrycodes,djGvNr5YYSpWyTSke3y6wGTtnKyBvn3IMHk8K3gjXPnFrQ==",
    "ht_countrycodes,djEQnxf63Vdha/zuXzXk9Mp9CDBQKD/daEgwrDg6kZqEXA==",
    "ht_countrycodes,djEea5atEKBeQfLp5bUeckqLVbWD16f/4QXfx7uucfYd5A==",
    "ht_countrycodes,djGp/DU6LXDmsX+R4sZ1kT2jy/V841BwkMVYEOybjHYcmQ==",
    "ht_countrycodes,djGChj5lLYBGNk4iGwWBHjjAh8Sq5syFGBesgwmb9TIcAQ==",
    "ht_countrycodes,djH2W+Dw04pMRTMt0AWnXOAPsJyt+gDt16bleiaRndw5Pw==",
    "ht_countrycodes,djFoGxiXK08kFSlasKv8aM8ZOsYnVWAjmfHzy4mpEEFlUw==",
    "ht_countrycodes,djHqn1lkJ900oysdRJlmUdBvKn37a44xr10V3e8BCH1XcA==",
    "ht_countrycodes,djHnyJFPsEimgGWmHfPuKvrLTFn7cGKeBYui6s2kqsjWww==",
    "ht_countrycodes,djEnHVuAsDH5vSbnnNw8gpmaHSWXxwH+Q7lE0TxbGvabPA==",
    "ht_countrycodes,djE9ZBYwhYg9qpgi2C/AHfSQwX2B0HFLd5Da66YJTqqXyg==",
    "ht_countrycodes,djG6bChhoFlMQNjJjSL9mnbxhaCrzpL5nE3vUs5Z8PtNcg==",
    "ht_countrycodes,djEOsRIGSENspvw3YFQsEhdGgcSKyvU1wa3fL3RuGP79ag==",
    "ht_countrycodes,djFUqEsGXCF8WFMY2wq+YYK4D8vFDYq3Xkj8SzIt5Gnq/g==",
    "ht_countrycodes,djFno15iUk26BGMva6fau9i7s5/OJLZqa5JUxuq/WX+TPQ==",
    "ht_countrycodes,djEewAb6pe1h0Aw/LcSNylXXBdzaO1XhDW6ujchfWFJZug==",
    "ht_countrycodes,djGk1s8gXrbu0Mgh2ZvXYMorNo/ThQPlvUchYNhfzt/ztg==",
    "ht_countrycodes,djHr7nC8a/Lj/0SNzxS+gP8FnqfIaiTVqAAQWayHnV8IyA==",
    "ht_countrycodes,djEhFQedT7EeSJkEJHEkF+QYJKwEzfLodtdp8eIOqtOE2w==",
    "ht_countrycodes,djHxRptu2WJ3C8mQZatmEdZGopSwEwULFps+MfozSLT0Dw==",
    "ht_countrycodes,djHLzdYV3hn5/NHd88MaAmFP+PJjmX2fITMA92e1mdENkg==",
    "ht_countrycodes,djH3TYnhqnzrdgteCgE5JRPy0vy5n8fACUSmzGxYL0ryUw==",
    "ht_countrycodes,djHg33Rba05qua87igcAqDm17xNfTYnLV0o8/SxAN95/+g==",
    "ht_countrycodes,djHI3kmpvYxQhZ/qBECrlZ6TFE0eCkR+s0gNjIUecj7spQ==",
    "ht_countrycodes,djGMcn4racuKzxVY+zbAHN1DcfWTT8dtkWjJu80GQ7m4Kw==",
    "ht_countrycodes,djH7BwRiyai1Ql8BN0ctuuaz7H4YcxSp5MQk5YvMDKDgCg==",
    "ht_countrycodes,djHrITVJcSP0jqyv6lHK+WdKlYzyF3Ig0n3Kej+49IVFIw==",
    "ht_countrycodes,djE/uVuBWnez+TJKlUWhlYIM3qDVZsraSYASth+crTDppQ==",
    "ht_countrycodes,djFwjZUAtttLHqsY8je9mBoYJDJHyqqHb+1bJvthBZbu4w==",
    "ht_countrycodes,djG5WLfv23vTYrIqV8tW2x7SIhxvEKQ09jk7wOEcGurkLQ==",
    "ht_countrycodes,djELAIMQUEREbQvA05uy1k+wkrpdtIeTnfCovJR522D0qg==",
    "ht_countrycodes,djH+pvUGn+LHA4PD3/ag2F8Df3Dy46VCGQHusA71V7eEsw==",
    "ht_countrycodes,djFhvKOPBlhzR4Jjv5BfRxme3dkY16P5yPX2O9NKujUiSA==",
    "ht_countrycodes,djHreYGx4TYrx8t8wkyOj8uaopjUjYwMIrUUGsGjwMnMPQ==",
    "ht_countrycodes,djFL+HI1qm8zt4yEBkrR0bSD82uh7/fH5iSIe6nNLv0jnA==",
    "ht_countrycodes,djFtXZYGZVQA5ebQGQKF8sjzA58moJW1OdKDrr/jHHvF+Q==",
    "ht_countrycodes,djHJB0HzwIRDKLDvlD7A13KkvpvRh5k9KGQ2fRqerhsAOw==",
    "ht_countrycodes,djHBtqvKHUPkGl2Wfd/gH5jiBAqRDqWhhQrSyrTzImx7BQ==",
    "ht_countrycodes,djHhebkkf0gtmAYwc9L2Cn+hnWYmQZk9MJ8Ga0wBURydtg==",
    "ht_countrycodes,djG9STkWhwzE7rh1BBp6WoS+YR4iPJSIAFMHozMUS/tWWg==",
    "ht_countrycodes,djE0Jkvn6VPu4+sUYfnwcL3I1Ut5N/vg8i8qMNNjW7BShg==",
    "ht_countrycodes,djGflwHKXY4/c8w6/xWhW299IhO0TpdN7YfBCai+WXg15g==",
    "ht_countrycodes,djG/NZI+l6Jpd+tgDZUBlMbIevBheYdqCUXHfLFPD5rNLA==",
    "ht_countrycodes,djE4jesHUOEvL3wsAWCFIU4Se/X4zwm9ZW8ZnR2+855qEw==",
    "ht_countrycodes,djFuiHnu6MxDuQ618cEaTPRwPCyw/UCNTwDF4Qp8sNNBwg==",
    "ht_countrycodes,djFm0U9SmKiqsUOjq6aAdbb70i7V9Vqk4dYodQDW1u364g==",
    "ht_countrycodes,djGTwdFvjzLomLIBlC/IdgS8MI7P/nxDEPV6EJYFdHEaNQ==",
    "ht_countrycodes,djEgkeUO1dLIm7x80WFdUilCDZcTUwCwEvnsCTYCEfqnxw==",
    "ht_countrycodes,djFe9uaRHEMv4Zs1oJsO7Ndo5VTbNqJ5cj6Y0MxyVVG45Q==",
    "ht_countrycodes,djFHAV4nb12kM/+14Zrp20hzmKSivkXyUFUSOrRxTb26Ag==",
    "ht_countrycodes,djFucTxL52x1fd/SjhTv2TSvs3gKcaz2oCXebmXvGKTAVw==",
    "ht_countrycodes,djFGCWu/qSlbHcW1BX994GOf07jr5Fm3lNVQOdt1gTQTLA==",
    "ht_countrycodes,djGdVYrl4TWQYtSYvtwIEkf7X1LO6aTglaVSKF+btY7+JA==",
    "ht_countrycodes,djERAdaEAjAKhtOuONaQg+9m5Jidm0NLT7YkjShgQ94p0g==",
    "ht_countrycodes,djF2zqcgpuuhdHpfswnwdx4uI1k8cSAy7lErfm1Bk0Bxgg==",
    "ht_countrycodes,djHDIdLEMnXAhwv2O1ctESfIfak70xlGK73+GsKyYR7aCw==",
    "ht_countrycodes,djH+m7M4l8g/i1w1UuoYyr4bWIOPeMdUgIiYwEsFYlMwWA=="
];

const showZipText = [
    "United States of America",
    "Afghanistan",
    "Albania",
    "Algeria",
    "Andorra",
    "Angola",
    "Armenia",
    "Austria",
    "Azerbaijan",
    "Bahrain",
    "Bangladesh",
    "Belarus",
    "Belgium",
    "Benin",
    "Bosnia and Herzegovina",
    "Botswana",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cameroon",
    "Cape Verde",
    "Central African Republic",
    "Chad",
    "Comoros",
    "Congo",
    "Congo, The Dem. Republic Of",
    "Côte d'Ivoire",
    "Croatia",
    "Cyprus",
    "Czech Republic",
    "Denmark",
    "Djibouti",
    "Egypt",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Ethiopia",
    "Finland",
    "France",
    "French Southern Terr.",
    "Gabon",
    "Gambia",
    "Georgia",
    "Germany",
    "Ghana",
    "Gibraltar",
    "Greece",
    "Guinea",
    "Guinea-Bissau",
    "Hungary",
    "Iceland",
    "India",
    "Iran",
    "Iraq",
    "Ireland",
    "Isle of Man",
    "Israel",
    "Italy",
    "Jersey",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kosovo",
    "Kuwait",
    "Kyrgyzstan",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Madagascar",
    "Malawi",
    "Mali",
    "Malta",
    "Mauritania",
    "Mauritius",
    "Mayotte",
    "Moldova",
    "Monaco",
    "Montenegro",
    "Morocco",
    "Mozambique",
    "Namibia",
    "Netherlands",
    "Niger",
    "Nigeria",
    "North Macedonia",
    "Norway",
    "Oman",
    "Pakistan",
    "Poland",
    "Portugal",
    "Qatar",
    "Romania",
    "Russian Federation",
    "Rwanda",
    "San Marino",
    "Sao Tome/Principe",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Slovak Republic",
    "Slovenia",
    "Somalia",
    "South Africa",
    "Spain",
    "Sri Lanka",
    "St. Helena",
    "Sudan",
    "Svalbard/Jan Mayen Isls.",
    "Swaziland",
    "Sweden",
    "Switzerland",
    "Syria",
    "Tajikistan",
    "Tanzania",
    "Togo",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "United Kingdom",
    "Uzbekistan",
    "Western Sahara",
    "Yemen",
    "Zambia",
    "Zimbabwe"
];
